(function(){
	'use strict';
	angular
	.module('myApp')
	.controller('UserDashboardCtrl', UserDashboardCtrl)
	UserDashboardCtrl.$inject = [
		'$rootScope',
		'$scope',
		'UserService',
		"$controller"
	];
	function UserDashboardCtrl(
		$rootScope,
		$scope,
		UserService,
		$controller
	){

		var ctrl = this;

		//Get the default functionality
		var base = $controller('BaseCtrl', { $scope: $scope });

		angular.extend(this, base)
		//member data
		ctrl.userId 		= '';
		ctrl.user 		= [];
		ctrl.states 		= [];
		ctrl.users 		= [];
		ctrl.peoplesearch = [];
		ctrl.peoplesearchcount = -1;
		ctrl.columns		= [
				{'class':'col-sm-2','field':'last','title':'Last Name'},
				{'class':'col-sm-2','field':'first','title':'First Name'},
				{'class':'col-sm-2','field':'username','title':'Username'},
				{'class':'col-sm-2','field':'email','title':'Email'}
			];


		//methods
		ctrl.loadUser = function(userId) {
			ctrl.userId = userId;
			UserService.getUser(ctrl.userId)
			.then(function(res){
				ctrl.user = res;
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM getUser: ", err);
			});
		}

		// Events Listener
		var createListener = $rootScope.$on('UserDashboardCtrl.create', function (event, data) {
			ctrl.tags.push(data.payload);
		});

		var updateListener = $rootScope.$on('UserDashboardCtrl.update', function (event, data) {
			//do nothing
		});

		var reloadListener = $rootScope.$on('UserDashboardCtrl.reload', function (event, data) {
			ctrl.loadView(ctrl.userId);
		});

		//Events Listener
		$scope.$on('$destroy', function(){
			createListener();
			updateListener();
			reloadListener();
		});
	}
})();
(function(){
	'use strict';
	angular
	.module('myApp')
	.controller('AddressCreateFormController', AddressCreateFormController)
	AddressCreateFormController.$inject = [
		'$rootScope',
		'$scope',
		'$uibModalInstance',
		'items',
		'AddressService',
		"$controller"
	];
		function AddressCreateFormController(
			$rootScope,
			$scope,
			$uibModalInstance,
			items,
			AddressService,
			$controller
		){

			var ctrl = this;

			//Get the default functionality for modal form
			var base = $controller('BaseFormCtrl', {$scope: $scope});

			angular.extend(this, base);

			if((items != undefined)&&(items.bind != undefined)) {
				ctrl.bind = items.bind;
				ctrl.originalObj = angular.extend({}, items.bind);
			}

			if((items != undefined)&&(items.expect != undefined)) {
				ctrl.expectEvent = items.expect;
			}

			ctrl.addAddress = function(){
				var data = ctrl.bind
				AddressService.addAddress(data)
				.then(function(res){
					// ctrl.addresses.push(res);
					ctrl.fireEvents(res);
					$uibModalInstance.close(res);
				})
				.catch(function(err){
					console.error("ERROR RESPONDING FROM addAddress: ", err);
				});
			}

			ctrl.parseAddressStr = function(){
				var data = {
					addressStr:ctrl.bind.addressStr
				}
				AddressService.parseAddress(data)
				.then(function(res){
					ctrl.bind.city = res.city;
					ctrl.bind.state = res.state;
					ctrl.bind.zip = res.zip;
					ctrl.bind.line_1 = res.line_1;
				})
				.catch(function(err){
					console.error("ERROR RESPONDING FROM addAddress: ", err);
				});
			}

			ctrl.updateAddress= function(){
				var data = ctrl.bind
				if(ctrl.assigned_parent.originalObject != undefined) {
					data.parent_id = ctrl.assigned_parent.originalObject.id
				}
				AddressService.updateAddress(ctrl.bind.id, data)
				.then(function(res){
					$uibModalInstance.close(ctrl.bind);
				})
				.catch(function(err){
					console.error("ERROR RESPONDING FROM updateAddress: ", err);
				});
			}

			ctrl.deleteAddress = function(addressId, idx){
				var data = ctrl.bind
				AddressService.deleteAddress(addressId)
				.then(function(res){
					ctrl.addresses.splice(idx, 1);
					ctrl.fireEvents(res);
				})
				.catch(function(err){
					console.error("ERROR RESPONDING FROM deleteAddress: ", err);
				});
			}

			ctrl.fireEvents = function (d) {
				if (ctrl.expectEvent != undefined && ctrl.expectEvent != '') {
					$rootScope.$emit(ctrl.expectEvent, d);
				} else {
					//
				}
			}

			$scope.ok = ctrl.ok = ctrl.addAddress;

			$scope.cancel = function () {
				if(ctrl.bind != undefined) {
					// angular.extend(ctrl.bind, originalObj);
				}
				$uibModalInstance.dismiss('cancel');
			};
	}
})();
(function(){
	'use strict';
	angular
	.module('myApp')
	.controller('AddressCtrl', AddressCtrl)
	AddressCtrl.$inject = ["$rootScope",
		"$scope",
		"AddressService",
		"$controller"
	];
	function AddressCtrl($rootScope,
		$scope,
		AddressService,
		$controller){

		var ctrl = this;
		//Get the default functionality
		var base = $controller('BaseCtrl', {$scope: $scope});

		angular.extend(this, base)

		 //methods
		ctrl.loadParentAddresses = function(parentId, parentType){
			ctrl.parentId = parentId;
			ctrl.parentType = parentType;
			AddressService.getAllAddressesByParent(ctrl.parentId,ctrl.parentType)
			.then(function(res){
				ctrl.addresses = res;
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM getAllAddressesByParent: ", err);
			});
		};

		ctrl.deleteAddress = function (address){
			if(confirm('Are you certain you want to delete this address?'))
			{
				AddressService.deleteAddress(address.uid)
				.then(function(res){
					var position = ctrl.addresses.map(function (address) {
						return address.id;
					}).indexOf(address.id);
					ctrl.addresses.splice(position, 1);
				})
				.catch(function(err){
					console.error("ERROR RESPONDING FROM deleteAddress: ", err);
				});
			}
		};

		// Events Listener
		var createListener = $rootScope.$on('AddressCtrl.create', function (event, data) {
			ctrl.addresses.push(data);
		});

		var updateListener = $rootScope.$on('AddressCtrl.update', function (event, data) {
			ctrl.loadAddresses(ctrl.parentId,ctrl.parentType);
		});

		var reloadListener = $rootScope.$on('AddressCtrl.reload', function (event, data) {
			ctrl.loadAddresses(ctrl.parentId,ctrl.parentType);
		});

		var deleteListener = $rootScope.$on('AddressCtrl.delete', function (event, data) {

		});

		//Events Listener
		$scope.$on('$destroy', function(){
			createListener();
			updateListener();
			reloadListener();
		});
	}
})();
(function(){
	'use strict';
	angular
	.module('myApp')
	.controller('AdminManagerController', AdminManagerController)
	AdminManagerController.$inject = [
		"$rootScope",
		"$scope",
		"RoleService",
		"LinkService",
		"ComponentService",
		"$controller"
	];
	function AdminManagerController(
		$rootScope,
		$scope,
		RoleService,
		LinkService,
		ComponentService,
		$controller
		){

		var ctrl = this;
		//Get the default functionality
		var base = $controller('BaseCtrl', {$scope: $scope});

		angular.extend(this, base)

		//member data
		ctrl.links							= [],
		ctrl.components						= [],
		ctrl.navigations 					= [],
		ctrl.converted_link_permissions 	= [],
		ctrl.converted_comp_permissions		= [],
		ctrl.converted_nav_permissions  	= [],
		ctrl.comp_roles 					= [],
		ctrl.searchQry						= {},
		ctrl.isCollapsed 					= true,
		ctrl.treeNav 						= {}

		//methods
		ctrl.loadRoles = function(){
			ctrl.isLoaded = false;
			if((ctrl.roles === undefined)||(ctrl.roles.length == 0)){
				RoleService.getAllRoles()
				.then(function(res){
					ctrl.roles = res;
					ctrl.isLoaded = true;
				})
				.catch(function(err){
					console.error("ERROR RESPONDING FROM loadRoles: ", err);
				});
			}
		};

		ctrl.changeLinkPermission = function (role,link){

			var permission = link.permissions[role.name] ? false : true;

			var post_data = {
				'link_id': link.id,
				'role_id': role.id,
			};
			// if this is true, we should be removing it
			if(permission){
				LinkService.detachRole(post_data)
				.then(function(res){
					link.permissions[role.name] = false;
				})
				.catch(function(err){
					console.error("ERROR RESPONDING FROM attachRole: ", err);
					link.permissions[role.name] = true;
				});
			}else{
				LinkService.attachRole(post_data)
				.then(function(res){
					link.permissions[role.name] = true;
				})
				.catch(function(err){
					console.error("ERROR RESPONDING FROM attachRole: ", err);
					link.permissions[role.name] = false;
				});
			}
		};

		ctrl.changeComponentPermission = function (role,component){

			var permission = component.permissions[role.name] ? false : true;

			var post_data = {
				'component_id': component.id,
				'role_id': role.id,
			};
			// if this is true, we should be removing it
			if(permission){
				ComponentService.detachRole(post_data)
				.then(function(res){
					component.permissions[role.name] = false;
				})
				.catch(function(err){
					console.error("ERROR RESPONDING FROM attachRole: ", err);
					component.permissions[role.name] = true;
				});
			}else{
				ComponentService.attachRole(post_data)
				.then(function(res){
					component.permissions[role.name] = true;
				})
				.catch(function(err){
					console.error("ERROR RESPONDING FROM attachRole: ", err);
					component.permissions[role.name] = false;
				});
			}
		};

		ctrl.changeNavigationPermission = function (role,link){
			var permission = link.permissions[role.name] ? false : true;

			var post_data = {
				'link_id': link.id,
				'role_id': role.id,
			};
			// if this is true, we should be removing it
			if(permission){
				LInkService.detachRole(post_data)
				.then(function(res){
					link.permissions[role.name] = false;
				})
				.catch(function(err){
					console.error("ERROR RESPONDING FROM attachRole: ", err);
					link.permissions[role.name] = true;
				});
			}else{
				LInkService.attachRole(post_data)
				.then(function(res){
					link.permissions[role.name] = true;
				})
				.catch(function(err){
					console.error("ERROR RESPONDING FROM attachRole: ", err);
					link.permissions[role.name] = false;
				});
			}
		};

		ctrl.treeNav = function(sourceNodeScope, destNodesScope, destIndex){
		}

		// Events Listeners
		var createListener = $rootScope.$on('AdminManagerController.create', function (event, data) {
			if(data.object.menu_item > 0 ){
				ctrl.navigations = ctrl.navigations.push(data.payload);
			}
		});
		var updateListener = $rootScope.$on('AdminManagerController.update', function (event, data)
		{
		});
		var destroyListener = $rootScope.$on('AdminManagerController.destroy', function (event, data)
		{
		});
		var deleteListener = $rootScope.$on('AdminManagerController.delete', function (event, data)
		{
		});
	}
})();

(function(){
	'use strict';
	angular
	.module('myApp')
	.controller('AlertCtrl', AlertCtrl)
	AlertCtrl.$inject = ["$rootScope",
		"$scope",
		"AlertService",
		"$controller"
	];
	function AlertCtrl($rootScope,
		$scope,
		AlertService,
		$controller){

		var ctrl = this;
		//Get the default functionality
		var base = $controller('BaseCtrl', {$scope: $scope});

		angular.extend(this, base)

		ctrl.alerts = [];
		ctrl.columns = [
			{ 'class': 'col-md-6', 'field': 'message', 'title': 'Message' },
			{ 'class': 'col-md-6', 'field': 'severity', 'title': 'Severity' }
		];
		ctrl.modColumns 	= [
			{'class':'col-md-6','field':'message','title':'Message'},
			{'class':'col-md-6','field':'severity','title':'Severity'}
		];

		//methods
		ctrl.loadParentAlerts = function(parentId,parentType){
			ctrl.parentId = parentId;
			ctrl.parentType = parentType;
			AlertService.getAllAlertsByParent(ctrl.parentId,ctrl.parentType)
			.then(function(res){
				ctrl.alerts = res;
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM getAlerts: ", err);
			});
		}

		ctrl.getAlerts = function(){
			AlertService.getAllAlerts()
			.then(function(res){
				ctrl.alerts = res;
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM getAlerts: ", err);
			});
		}

		ctrl.loadAlert = function(alertsId){
			AlertsService.getAlerts(alertsId)
			.then(function(res){
				ctrl.alert = res;
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM getAlerts: ", err);
			});
		}


		ctrl.deleteAlert = function (alert){
			if(confirm('Are you sure you want to delete this alert?')){
				AlertService.deleteAlert(alert.uid)
				.then(function(res){
					var position = ctrl.alerts.map(function (alert) {
						return alert.id;
					}).indexOf(alert.id);
					ctrl.alerts.splice(position, 1);
				})
				.catch(function(err){
					console.error("ERROR RESPONDING FROM GET ALL USERS: ", err);
				});
			}
		}


		// Events Listener
		var createListener = $rootScope.$on('AlertCtrl.create', function (event, data) {
			ctrl.alerts.push(data.payload);
		});
		var updateListener = $rootScope.$on('AlertCtrl.update', function (event, data) {
			// do nothing
		});
		var deleteListener = $rootScope.$on('AlertCtrl.destroy', function (event, data) {
			var position = ctrl.alerts.map(function(alerts){
				return alerts.id;
			}).indexOf(data.payload.id);
			ctrl.alerts.splice(position,1);
		});

		$scope.$on('$destroy', function(){
			createListener();
			updateListener();
		});
	}
})();

(function(){
	'use strict';
	angular
	.module('myApp')
	.controller('ApprovalCtrl', ApprovalCtrl)
	ApprovalCtrl.$inject = [
		"$rootScope",
		"$scope",
		"$controller",
		"ApprovalService",
		"StewardService"
	];
	function ApprovalCtrl(
		$rootScope,
		$scope,
		$controller,
		ApprovalService,
		StewardService
	){

		var ctrl = this;
		//Get the default functionality
		var base = $controller('BaseCtrl', {$scope: $scope});

		angular.extend(this, base)

		$scope.columns		 = [
			{'class':'col-sm-3','field':'approved_by','title':'Approved By'},
			{'class':'col-sm-3','field':'approved_details','title':'Approved Details'},
		];

		ctrl.stewards = [];

		 //methods
		ctrl.loadApprovalsModule = function(parentId, parentType){
			ctrl.parentId = parentId;
			ctrl.parentType = parentType;
			ApprovalService.getAllApprovalsByParent(ctrl.parentId, ctrl.parentType)
			.then(function(res){
				ctrl.approvals = res;
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM getAllApprovalsByParent: ", err);
			});
		};

		ctrl.loadUserStewards = function(entityId){
			ctrl.entityId = entityId;
			StewardService.getAllStewardsByCurrentUser(entityId)
			.then(function(res){
				ctrl.stewards = res;
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM getAllApprovalsByParent: ", err);
			});
		};

		ctrl.canApprove = function(assignable){
			if (assignable == undefined) {
				return false;
			}
			var approves = ctrl.stewards.indexOf(assignable.id);
			if (approves == -1) {
				return false;
			}
			return true
		}

		ctrl.deny = function(approvalObj){
			var data = {};
			ApprovalService.updateApprovalDeny(approvalObj.uid, data)
				.then(function (res) {
					// approval = res;
					var position = ctrl.approvals.map(function (approval) {
						return approval.id;
					}).indexOf(approvalObj.id);
					ctrl.approvals[position] = res;
				})
				.catch(function (err) {
					console.error("ERROR RESPONDING FROM updateApproval: ", err);
				});

		}

		ctrl.approve = function (approvalObj){
			var data = {};
			ApprovalService.updateApprovalApprove(approvalObj.uid, data)
				.then(function (res) {
					var position = ctrl.approvals.map(function (approval) {
						return approval.id;
					}).indexOf(approvalObj.id);
					ctrl.approvals[position] = res;
				})
				.catch(function (err) {
					console.error("ERROR RESPONDING FROM updateApproval: ", err);
				});

		}

		// Events Listener
		var createListener = $rootScope.$on('ApprovalCtrl.create', function (event, data) {
			ctrl.approvals.push(data);
		});

		var updateListener = $rootScope.$on('ApprovalCtrl.update', function (event, data) {
			ctrl.loadApprovalsModule(ctrl.parentId,ctrl.parentType);
		});

		var reloadListener = $rootScope.$on('ApprovalCtrl.reload', function (event, data) {
			ctrl.loadApprovalsModule(ctrl.parentId,ctrl.parentType);
		});

		var deleteListener = $rootScope.$on('ApprovalCtrl.delete', function (event, data) {
			var position = ctrl.approvals.map(function (approval) {
				return approval.id;
			}).indexOf(data.id);
			ctrl.approvals.splice(position, 1);

		});

		//Events Listener
		$scope.$on('$destroy', function(){
			createListener();
			updateListener();
			reloadListener();
		});
	}
})();
(function(){
	'use strict';
	angular
	.module('myApp')
	.controller('AttachmentCtrl', AttachmentCtrl)
	AttachmentCtrl.$inject = [
		'$rootScope',
		'$scope',
		'AttachmentService',
		'ApprovalService',
		'TagService',
		"$controller"
	];
		function AttachmentCtrl(
			$rootScope,
			$scope,
			AttachmentService,
			ApprovalService,
			TagService,
			$controller
		){

			var ctrl = this;
			//Get the default functionality
			var base = $controller('BaseCtrl', {$scope: $scope});

			angular.extend(this, base)

			//member data
			ctrl.field = ['archived_at','created_at']
			ctrl.pageSize		= 12,
			ctrl.uploadLoaded = true;
			ctrl.attachmentCode = '';
			ctrl.uploads = [];
			ctrl.extensions = {
				'.zip':'fa-file-archive-o',
				'.pdf':'fa fa-file-pdf-o',
				'.PDF':'fa fa-file-pdf-o',
				'.png':'fa fa-file-image-o',
				'.tif':'fa fa-file-image-o',
				'.jpeg':'fa fa-file-image-o',
				'.jpg':'fa fa-file-image-o',
				'.doc':'fa fa-file-word-o',
				'.docx':'fa fa-file-word-o',
				'.docm':'fa fa-file-word-o',
				'.rtf':'fa fa-file-word-o',
				'.xls':'fa fa-file-excel-o',
				'.xlsx':'fa fa-file-excel-o',
				'.xlsm':'fa fa-file-excel-o',
				'.csv':'fa fa-file-excel-o',
				'.eml':'fa fa-envelope-o',
				'.msg':'fa fa-envelope-o',
			};

			ctrl.classByExtension = function (fileExtension) {
				if (ctrl.extensions[fileExtension] != undefined) {
					return ctrl.extensions[fileExtension];
				}
				return 'fa fa-file';
			}

			//methods
			ctrl.loadParentAttachments = function(parentId, parentType){
				ctrl.parentId = parentId;
				ctrl.parentType = parentType;
				AttachmentService.getAllAttachmentsByParent(ctrl.parentId,ctrl.parentType)
				.then(function(res){
					ctrl.attachments = res;
					ctrl.isLoaded = true;
				})
				.catch(function(err){
					console.error("ERROR RESPONDING FROM getAllAttachmentsByParent: ", err);
				});
			};

			ctrl.loadParentMedia = function(parentId, parentType){
				ctrl.parentId = parentId;
				ctrl.parentType = parentType;
				AttachmentService.getAllMediaByParent(ctrl.parentId,ctrl.parentType)
				.then(function(res){
					ctrl.media = res;
					ctrl.isLoaded = true;
				})
				.catch(function(err){
					console.error("ERROR RESPONDING FROM getAllAttachmentsByParent: ", err);
				});
			};

			ctrl.requestApproval = function(attachment){
				var payload = {
					'userId': 	ctrl.userId,
					'parentId': 	attachment.id,
					'_token': 		ctrl.crsfToken,
				}
				ApprovalService.requestApproval(payload)
				.then(function(res){
					if (!attachment.hasOwnProperty('approvals')) {
						attachment.approvals = [];
					}
					if (!attachment.approvals == undefined) {
						attachment.approvals = [];
					}
					attachment.approvals.push(res.payload);
				})
				.catch(function(err){
					console.error("ERROR RESPONDING FROM addApproval: ", err);
				});
			};

			ctrl.deleteAttachment= function (attachment, idx){
				if(confirm('Are you sure you want to delete this attachment?')){
					AttachmentService.deleteAttachment(attachment.uid)
					.then(function(res){
						ctrl.attachments.splice(idx, 1);
					})
					.catch(function(err){
						console.error("ERROR RESPONDING FROM GET ALL USERS: ", err);
					});
				}
			}

			ctrl.preferAttachment= function (attachment, idx){
				if(confirm('Do you want to mark this one preferred?')){
					AttachmentService.preferAttachment(attachment.uid)
					.then(function(res){
						var position = ctrl.attachments.map(function (attachment) {
							attachment.preferred = false;
							return attachment.id;
						}).indexOf(res.id);
						ctrl.attachments[position] = res;
					})
					.catch(function(err){
						console.error("ERROR RESPONDING FROM GET ALL USERS: ", err);
					});
				}
			}

			ctrl.archiveAttachment = function (attachment){
				if(confirm('Are you sure you want to archive this attachment?')){
					var timestamp = moment().format('YYYY-MM-DD HH:mm:ss');
					var data = {
						archived_at: timestamp
					};
					AttachmentService.updateAttachment(attachment.uid, data)
					.then(function(res){
						var position = ctrl.attachments.map(function (attachment) {
							return attachment.id;
						}).indexOf(attachment.id);
						ctrl.attachments[position] = res;
					})
					.catch(function(err){
						console.error("ERROR RESPONDING FROM GET ALL USERS: ", err);
					});
				}
			}

			ctrl.unarchiveAttachment = function (attachment){
				if(confirm('Are you sure you want to UNarchive this attachment?')){
					var data = {
						archived_at: null
					};
					AttachmentService.updateAttachment(attachment.uid, data)
					.then(function(res){
						var position = ctrl.attachments.map(function (attachment) {
							return attachment.id;
						}).indexOf(attachment.id);
						ctrl.attachments[position] = res;
					})
					.catch(function(err){
						console.error("ERROR RESPONDING FROM GET ALL USERS: ", err);
					});
				}
			}

			ctrl.toggleTagAttachment = function (attachment, newTag){
				var position = attachment.tags.map(function (tag) {
					return tag.tag;
				}).indexOf(newTag);

				// if it isn't there create it
				if(position == -1){
					var data = {
						tag: newTag,
						parentType: ctrl.attachmentCode,
						parentId: attachment.id,
					}
					TagService.addTag(data)
					.then(function (res) {
						attachment.tags.push(res);
					})
					.catch(function (err) {
						console.error("ERROR RESPONDING FROM addTag: ", err);
					});
				} else { // if it is, delete it
					TagService.deleteTag(attachment.tags[position].id)
					.then(function (res) {
						attachment.tags.splice(position, 1);
					})
					.catch(function (err) {
						console.error("ERROR RESPONDING FROM addTag: ", err);
					});

				}
			}

			ctrl.attachmentHasTag = function (attachment, checkTag){
				if (!attachment.tags.length) {
					return "btn-white";
				}
				var position = attachment.tags.map(function (tag) {
					return tag.tag;
				}).indexOf(checkTag);
				if (position == -1) {
					return "btn-white";
				}
				return 'btn-accent-1';
			}

			ctrl.tagsByAttachment = function (attachment){
				TagService.getAllTagsByParent(attachment.id, ctrl.attachmentCode)
				.then(function (res) {
					attachment.tags = res;
				})
				.catch(function (err) {
					console.error("ERROR RESPONDING FROM addTag: ", err);
				});
			}

			// Events Listener
			var createListener = $rootScope.$on('AttachmentCtrl.create', function (event, data) {
				var position = ctrl.uploads.map(function (upload) {
					return upload.id;
				}).indexOf(data.uploadId);
				ctrl.uploads.splice(position, 1);
				ctrl.attachments.unshift(data);
			});

			// Events Listener
			var createListener = $rootScope.$on('fileUpload', function (event, data) {
				ctrl.uploads.unshift(data);
			});

			var createListener = $rootScope.$on('fileUploadError', function (event, data) {
				var position = ctrl.uploads.map(function (upload) {
					return upload.id;
				}).indexOf(data.uploadId);

				ctrl.uploads[position] = data;
			});

			var updateListener = $rootScope.$on('AttachmentCtrl.update', function (event, data) {
				var position = ctrl.attachments.map(function (attachment) {
					return attachment.id;
				}).indexOf(data.id);
				ctrl.attachments[position] = data;
			});

			var reloadListener = $rootScope.$on('AttachmentCtrl.reload', function (event, data) {
				//do nothing
			});

			//Events Listener
			$scope.$on('$destroy', function(){
				createListener();
				updateListener();
				reloadListener();
			});
	}
})();
(function(){
	'use strict';
	angular
	.module('myApp')
	.controller('BaseCtrl', BaseCtrl)
	BaseCtrl.$inject = [
		"$rootScope",
		"$scope",
		"$http",
		"$filter",
		"$uibModal",
		'orderByFilter',
		'$sce',
		'$log',
		'growl',
	];
	function BaseCtrl(
		$rootScope,
		$scope,
		$http,
		$filter,
		$uibModal,
		orderBy,
		$sce,
		$log,
		growl
		){

		var properties = {
			array_pages 	: [],
			class			: 'fa-plus-circle',
			current_page	: 1,
			data_url		: '',
			errors			: [],
			rawErrors		: [],
			field 			: 'title',
			hasError		: false,
			isAdvanceSearch	: false,
			isLoaded 		: false,
			isReverse		: true,
			isSearchDone 	: false,
			item			: {},
			itemsPerPage	: 25,
			link			: 'show more',
			num_pages		: 0,
			offset 			: 0,
			pageSize		: 25,
			maxRecords		: 1000,
			parentId		: '',
			parentType		: '',
			records			: [],
			search 			: '',
			searchAdvText 	: 'advanced',
			searchDB		: '',
			searchFields	: [],
			searchQry		: {},
			showControl 	: false,
			showMenu 		: false,
			uploadLoaded	: true,
			showSearch		: false,
		};

		var methods = {
			changeFilterTo : function(){
				this.searchQry = {};
				this.isAdvanceSearch = !this.isAdvanceSearch;
				this.searchAdvText = this.isAdvanceSearch ? 'simple' : 'advanced';
			},
			sortBy : function(propertyName, reverse) {
				if (reverse == undefined) {
					this.isReverse = (propertyName !== null && this.field === propertyName)? !this.isReverse : false;
				} else {
					this.isReverse = reverse;
				}
				this.field = propertyName;
			},
			convert_text_to_html : function(text) {
				return $sce.trustAsHtml(text);
			},
			reloadData : function() {
				this.loadData(this.parentId, this.parentType);
			},
			addSearchField : function(newSearchField){
				this.searchFields.push(newSearchField);
			},
			processErrors: function (errors) {
				this.rawErrors = errors;
				var processedErrors = [];
				angular.forEach(errors, function (value, key) {
					angular.forEach(value, function (message, idx) {
						processedErrors.push(message);
					});
				});
				this.errors = processedErrors;
				return processedErrors;
			},
			fieldHasError: function(field){
				return typeof this.rawErrors[field] != 'undefined' ? 'has-error' : '';
			},
			getFieldError: function(field){
				var err = this.rawErrors[field];
				if(typeof err != 'undefined'){
					return err.join();
				}
			},
			fireEvents : function(d) {
				if(expectEvent != undefined && expectEvent != ''){
					$rootScope.$emit(expectEvent, d);
				}
			},
			growl: growl
		};

		angular.extend(this, properties)
		angular.extend(this, methods)

		return this;

	};
})();

(function(){
	'use strict';
	angular
	.module('myApp')
	.controller('BaseFormCtrl', BaseFormCtrl)
	BaseFormCtrl.$inject = [
		'$controller',
		'$filter' ,
		'$http',
		'$log',
		'$rootScope',
		'$sce',
		'$scope',
		'$uibModal',
		'FileUploadService',
		'growl',
		'orderByFilter'
	];
	function BaseFormCtrl(
		$controller,
		$filter,
		$http,
		$log,
		$rootScope,
		$sce,
		$scope,
		$uibModal,
		FileUploadService,
		growl,
		orderBy
		){

		var properties = {
			data_url		: '',
			errors			: [],
			hasError		: false,
			isAdvanceSearch	: false,
			isLoaded 		: false,
			isReverse		: true,
			isSearchDone 	: false,
			item			: {},
			parentId		: '',
			parentType		: '',
			records			: [],
			uploadLoaded	: true,
			assigned_parent : {id:0},
			submitDisabled	: false,
			expectEvent		: '',
		};

		var methods = {
			processErrors: function (res) {
				var processedErrors = [];
				angular.forEach(res.errors, function (value, key) {
					angular.forEach(value, function (message, idx) {
						processedErrors.push(message);
					});
				});
				return processedErrors;
			},
			ok : function() {
				alert('ok() method fired. You should really have this method do something!');
			},
			disableButton : function() {
				this.submitDisabled = true;
			},
			cancel : function () {
				$uibModalInstance.dismiss('cancel');
			},
			growl: growl
		}

		angular.extend(this, properties)
		angular.extend(this, methods)

		return this;

	}
})();
(function(){
	'use strict';
	angular
	.module('myApp')
	.controller('CartPageCtrl', CartPageCtrl)
	CartPageCtrl.$inject = [
		"$rootScope",
		"$scope",
		"$log",
		"$http",
		"$filter",
		"$uibModal",
		"TestimonialService",
		"BarService",
		"StateService",
		"ProductService",
		"CartService",
		"$controller",
		"$window"
	];
	function CartPageCtrl(
		$rootScope,
		$scope,
		$log,
		$http,
		$filter,
		$uibModal,
		TestimonialService,
		BarService,
		StateService,
		ProductService,
		CartService,
		$controller,
		$window){
		var ctrl = this;

		//Get the default functionality
		var base = $controller('BaseCtrl', {$scope: $scope});

		angular.extend(this, base)

		ctrl.columns = [
			{'class':'col-md-10','field':'quote','title':'Quote'}
		];
		ctrl.cart = [];
		ctrl.orderField = ctrl.columns[0];

		// go to course page
		ctrl.getCart = function(){
			CartService.getCart()
			.then(function(res){
				ctrl.cart = res;
				// $log.debug('Cart contents:',ctrl.cart.contents);
			})
			.catch(function(err){
				$log.error("ERROR RESPONDING FROM getCart: ", err); 
			});
		}

		ctrl.removeItem = function(item, idx){
			CartService.deleteCartItem(item.rowId)
			.then(function(res){
				ctrl.getCart();
			})
			.catch(function(err){
				$log.error("ERROR RESPONDING FROM getCart: ", err); 
			});
		}


		// Events Listeners
		var createListener = $rootScope.$on('CartPageCtrl.create', function (event, data) {
			// do nothing
		});

		var updateListener = $rootScope.$on('CartPageCtrl.update', function (event, data) {
			// do nothing
		});

		var deleteListener = $rootScope.$on('CartPageCtrl.destroy', function (event, data) {
			// do nothing
		});
		
		var deleteListener = $rootScope.$on('CartPageCtrl.refresh', function (event, data) {
			// do nothing
			ctrl.getCart();
		});
		
		$scope.$on('$destroy', function(){
			createListener();
			updateListener();
		});
	}
})();
(function(){
	'use strict';
	angular
	.module('myApp')
	.controller('CategoryCtrl', CategoryCtrl)
	CategoryCtrl.$inject = [
		"$rootScope",
		"$scope",
		"CategoryService",
		"$controller"
	];
	function CategoryCtrl(
		$rootScope,
		$scope,
		CategoryService,
		$controller
	){

		var ctrl = this;
		//Get the default functionality
		var base = $controller('BaseCtrl', {$scope: $scope});

		angular.extend(this, base)

		ctrl.field = 'title';
		ctrl.isReverse = true;
		ctrl.itemsPerPage = 100;
		ctrl.isTabulated = false;
		ctrl.categoryCount	= 0;
		ctrl.columns 			= [
			{'class':'col-md-2','field':'name','title':'Type'},
			{'class':'col-md-3','field':'name','title':'Category Name'},
			{'class':'col-md-6','field':'description','title':'Description'}
		];

		ctrl.getCategories = function(){
			CategoryService.getAllCategories(ctrl.searchDB)
			.then(function(res){
				ctrl.categories = res.data;
				ctrl.categoryCount = res.count;
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM getCategories: ", err);
			});
		};

		ctrl.getCategory = function(categoryId){
			CategoryService.getCategory(categoryId)
			.then(function(res){
				ctrl.category = res;
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM getCategories: ", err);
			});
		};

		ctrl.loadParentCategories = function(parentId,parentType){
			ctrl.parentId = parentId;
			ctrl.parentType = parentType;
			CategoryService.getAllCategoriesByParent(parentId,parentType)
			.then(function(res){
				ctrl.categories = res;
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM getCategories: ", err);
			});
		};

		ctrl.deleteCategory= function (categoryId, idx){
			if(confirm('Are you sure you want to delete this category?')){
				CategoryService.deleteCategory(categoryId)
				.then(function(res){
					ctrl.categories.splice(idx, 1);
					ctrl.fireEvents(res);
				})
				.catch(function(err){
					console.error("ERROR RESPONDING FROM GET ALL USERS: ", err);
				});
			}
		};

		// Events Listener
		var createListener = $rootScope.$on('CategoryCtrl.create', function (event, data) {
			ctrl.categories.push(data.payload);
		});
		var updateListener = $rootScope.$on('CategoryCtrl.update', function (event, data) {
			// do nothing
		});
		var deleteListener = $rootScope.$on('CategoryCtrl.destroy', function (event, data) {
			var position = ctrl.categories.map(function(category){
				return category.id;
			}).indexOf(data.object.id);
			ctrl.categories.splice(position,1);
		});

		$scope.$on('$destroy', function(){
			createListener();
			updateListener();
		});
	}
})();
(function(){
	'use strict';
	angular
	.module('myApp')
	.controller('ChangeCtrl', ChangeCtrl)
	ChangeCtrl.$inject = ['$rootScope','$scope', '$http','$sce','ChangeService',"$controller"];
		function ChangeCtrl($rootScope, $scope, $http, $sce, ChangeService, $controller){

			var ctrl = this;
			//Get the default functionality
			var base = $controller('BaseCtrl', {$scope: $scope});

			angular.extend(this, base)

			ctrl.columns		= [
					{'class':'col-md-3','field':'created_at','title':'Date'},
					{'class':'col-md-3','field':'user.fullname','title':'Who'},
					{'class':'col-md-3','field':'old_value','title':'Before'},
					{'class':'col-md-3','field':'new_value','title':'After'},
				]

			//methods
			ctrl.loadParentChanges = function(parentId, parentType){
				ctrl.parentId = parentId;
				ctrl.parentType = parentType;
				ChangeService.getAllChangesByParent(ctrl.parentId, ctrl.parentType)
				.then(function(res){
					ctrl.changes = res;
					ctrl.isLoaded = true;
				})
				.catch(function(err){
					console.error("ERROR RESPONDING FROM getAllChangesByParent: ", err);
				});
			}

			// Events Listener
			var createListener = $rootScope.$on('ChangeCtrl.create', function (event, data) {
				ctrl.changes.push(data.payload);
			});

			var updateListener = $rootScope.$on('ChangeCtrl.update', function (event, data) {
				//do nothing
			});

			var reloadListener = $rootScope.$on('ChangeCtrl.reload', function (event, data) {
				ctrl.loadParentChanges(ctrl.parentId, ctrl.parentType)
			});

			//Events Listener
			$scope.$on('$destroy', function(){
				createListener();
				updateListener();
				reloadListener();
			});
	}
})();
(function(){
	'use strict';
	angular
	.module('myApp')
	.controller('CheckoutPageCtrl', CheckoutPageCtrl)
	CheckoutPageCtrl.$inject = [
		"$rootScope",
		"$scope",
		"$log",
		"CartService",
		"PaymentService",
		"$controller",
		"$window"
	];
	function CheckoutPageCtrl(
		$rootScope,
		$scope,
		$log,
		CartService,
		PaymentService,
		$controller,
		$window){
		var ctrl = this;

		//Get the default functionality
		var base = $controller('BaseCtrl', {$scope: $scope});

		angular.extend(this, base)

		ctrl.columns = [
			{'class':'col-md-10','field':'quote','title':'Quote'}
		];
		ctrl.cart = [];
		ctrl.orderField = ctrl.columns[0];
		ctrl.checkout = {
			payment_type:'ccard'
		};

		// go to course page
		ctrl.getCart = function(){
			CartService.getCart()
			.then(function(res){
				ctrl.cart = res;
				// $log.debug('Cart contents:',ctrl.cart.contents);
			})
			.catch(function(err){
				$log.error("ERROR RESPONDING FROM getCart: ", err);
			});
		}

		ctrl.removeItem = function(item, idx){
			CartService.deleteCartItem(item.rowId)
			.then(function(res){
				ctrl.getCart();
			})
			.catch(function(err){
				$log.error("ERROR RESPONDING FROM getCart: ", err);
			});
		}

		ctrl.makePayment = function(){
			var paymentInfo = {
				checkout:ctrl.checkout,
			};
			if(ctrl.checkout.payment_type == 'ccard') {
				PaymentService.addCCPayment(ctrl.checkout)
				.then(function(res){
					$window.location.href = "/student-dashboard";
				})
				.catch(function(err){
					if(err.status == 422){
						ctrl.errors = ctrl.processErrors(err.data);
					}
					$log.error("ERROR RESPONDING FROM getCart: ", err);
				});
			}else if(ctrl.checkout.payment_type == 'echeck'){
				PaymentService.addACHPayment(ctrl.checkout)
				.then(function(res){
					$window.location.href = "/student-dashboard";
				})
				.catch(function(err){
					if(err.status == 422){
						ctrl.errors = ctrl.processErrors(err.data);
					}
					$log.error("ERROR RESPONDING FROM getCart: ", err);
				});
			}else if(ctrl.checkout.payment_type == 'free'){
				// return;
				PaymentService.addFreePayment(ctrl.checkout)
				.then(function(res){
					$window.location.href = "/student-dashboard";
				})
				.catch(function(err){
					if(err.status == 422){
						ctrl.errors = ctrl.processErrors(err.data);
					}
					$log.error("ERROR RESPONDING FROM getCart: ", err);
				});
			}
		}

		// Events Listeners
		var createListener = $rootScope.$on('CheckoutPageCtrl.create', function (event, data) {
			// do nothing
		});

		var updateListener = $rootScope.$on('CheckoutPageCtrl.update', function (event, data) {
			// do nothing
		});

		var deleteListener = $rootScope.$on('CheckoutPageCtrl.destroy', function (event, data) {
			// do nothing
		});

		var deleteListener = $rootScope.$on('CheckoutPageCtrl.refresh', function (event, data) {
			// do nothing
			ctrl.getCart();
		});

		$scope.$on('$destroy', function(){
			createListener();
			updateListener();
		});
	}
})();
(function(){
	'use strict';
	angular
	.module('myApp')
	.controller('ComponentCtrl', ComponentCtrl)
	ComponentCtrl.$inject = ["$rootScope","$scope","$http","$filter","$uibModal","ComponentService","RoleService","$controller"];
	function ComponentCtrl($rootScope,$scope, $http, $filter, $uibModal,ComponentService, RoleService, $controller){

		var ctrl = this;

		//Get the default functionality
		var base = $controller('BaseCtrl', {$scope: $scope});

		angular.extend(this, base)

		//member data
		ctrl.roles 					= [];
		ctrl.converted_permissions 	= [],
		ctrl.columns 				= [
			{'class':'col-md-3','field':'name','title':'Name'},
			{'class':'col-md-3','field':'filename','title':'Filename'},
			{'class':'col-md-4','field':'description','title':'Description'}
		];

		//methods
		ctrl.loadPageComponents = function(){
			ctrl.isLoaded = false;
			ComponentService.getSessionComponents()
			.then(function(res){
				ctrl.modules = res;
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM getSessionComponents: ", err);
			});
		};

		ctrl.loadComponents = function()
		{
			ctrl.isLoaded = false;
			ComponentService.getAllComponents()
			.then(function(res){
				ctrl.modules = res;
				ctrl.loadRoles();
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM getAllComponents: ", err);
			});
		};

		ctrl.loadRoles = function(){
			ctrl.isLoaded = false;
			RoleService.getAllRoles()
			.then(function(res){
				ctrl.roles = res;
				$scope.roles = ctrl.roles
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM getAllRoles: ", err);
			});
		};

		ctrl.deleteComponent= function (id,idx){
			if(confirm('Are you certain you want to delete this component?'))
			{
				ComponentService.deleteComponent(id)
				.then(function(res){
					ctrl.addresses.splice(idx, 1);
				})
				.catch(function(err){
					console.error("ERROR RESPONDING FROM deleteComponent: ", err);
				});
			}


		};

		ctrl.changeComponentPermission = function (role,component){

			var permission = component.permissions[role.name] ? true : false;

			var post_data = {
				'component_id': component.id,
				'role_id': role.id,
			};
			// if this is true, we should be removing it
			if(permission){
				ComponentService.detachRole(post_data)
				.then(function(res){
					component.permissions[role.name] = false;
				})
				.catch(function(err){
					console.error("ERROR RESPONDING FROM attachRole: ", err);
					component.permissions[role.name] = true;
				});
			}else{
				ComponentService.attachRole(post_data)
				.then(function(res){
					component.permissions[role.name] = true;
				})
				.catch(function(err){
					console.error("ERROR RESPONDING FROM attachRole: ", err);
					component.permissions[role.name] = false;
				});
			}
		};

		// ctrl.changePermission = function (data){

		// 	var component_id = data.$parent.component.id;
		// 	var role_id = data.role.id;

		// 	var roles = data.$parent.component.roles;

		// 	var res = roles.filter(function(role){
		// 		return role.id == role_id;
		// 	});

		// 	var permission = res.length ? false : true;

		// 	$data = {
		// 		'component_id': component_id,
		// 		'role_id': role_id,
		// 		'events': permission
		// 	};

		// 	$http.post('/component-permission', $data).success(function(data){
		// 	});
		// };

		ctrl.showPermission = function()
		{
			ctrl.isLoaded = false;

			ctrl.roles.map(function(r){
				var role_id = r.id;
				var role = '';

				var index = [];

				ctrl.modules.map(function(component){
					var roles = component.roles;
					var res = roles.filter(function(role){
						var hasRole =  role.id == role_id;

						if(hasRole){
							index.push(role.id + ' ' + component.id);
						}

						return hasRole;
					});

					var hasRole = res.length ? true : false;

					index.map(function(i){
						ctrl.converted_permissions[i] = true;
					});

					return hasRole;
				});

			});

			ctrl.isLoaded = true;
		}

		// Events Listener
		var createListener = $rootScope.$on('ComponentCtrl.create', function (event, data) {
			ctrl.modules.push(data.payload);
			//$scope.showPermission();
		});
		var updateListener = $rootScope.$on('ComponentCtrl.update', function (event, data) {
			//do nothing
		});

		$scope.$on('$destroy', function(){
			createListener();
			updateListener();
		});
	}
})();
(function(){
	'use strict';
	angular
	.module('myApp')
	.controller('EmailCtrl', EmailCtrl)
	EmailCtrl.$inject = ["$rootScope","$scope","$http","$filter","$uibModal","EmailService","$controller"];
	function EmailCtrl($rootScope,$scope, $http, $filter, $uibModal, EmailService, $controller){
		var ctrl = this;

		//Get the default functionality
		var base = $controller('BaseCtrl', {$scope: $scope});

		angular.extend(this, base)

		ctrl.columns 			= [
			{'class':'col-md-2','field':'label','title':'Label'},
			{'class':'col-md-2','field':'email','title':'Email'},
			{'class':'col-md-2','field':'description','title':'Description'},
			{'class':'col-md-2','field':'preferred','title':'Preferred'},
		];
		ctrl.modColumns 			= [
			{'class':'col-md-2','field':'label','title':'Label'},
			{'class':'col-md-2','field':'email','title':'Email'},
			{'class':'col-md-2','field':'description','title':'Description'},
			{'class':'col-md-2','field':'preferred','title':'Preferred'},
		];
		ctrl.orderField 		= ctrl.columns[0];
		ctrl.emails			= [];
		ctrl.email			= {};
		ctrl.isTabulated= true;
		ctrl.showSearch = false;


		// get all Emails
		ctrl.getEmails = function(){
			EmailService.getAllEmails(ctrl.searchDB)
			.then(function(res){
				ctrl.emails = res.data;
				ctrl.sortBy(ctrl.orderField.field);
				ctrl.emailCount = res.count;
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM getEmails: ", err); 
			});
		}

		// get all Emails for a specific parent
		ctrl.getEmailsModule = function(parentId,parentType){
			ctrl.parentId = parentId;
			ctrl.parentType = parentType;
			EmailService.getAllEmailsByParent(parentId,parentType)
			.then(function(res){
				ctrl.emails = res;
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM getEmails: ", err); 
			});
		}

		// get a specific Email
		ctrl.getEmail = function(emailId){
			EmailService.getEmail(emailId)
			.then(function(res){
				ctrl.email = res;
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM getEmails: ", err); 
			});
		}

		// delete a specific Email
		ctrl.deleteEmail= function (email){
			if(confirm('Are you sure you want to delete this email?')){
				EmailService.deleteEmail(email.uid)
				.then(function(res){
					var position = ctrl.emails.map(function(email){
						return email.id;
					}).indexOf(email.id);
					ctrl.emails.splice(position, 1);
					ctrl.fireEvents(res);
				})
				.catch(function(err){
					console.error("ERROR RESPONDING FROM GET ALL USERS: ", err); 
				});
			}
		}

		// Search all Emails
		ctrl.searchEmails = function(){
			EmailService.getAllEmails(ctrl.searchDB)
			.then(function(res){
				ctrl.emails = res.data;
				ctrl.emailCount = res.count;
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM searchEmails: ", err); 
			});
		}

		// Events Listeners
		var createListener = $rootScope.$on('EmailCtrl.create', function (event, data) {
			ctrl.emails.push(data.payload);
		});
		var updateListener = $rootScope.$on('EmailCtrl.update', function (event, data) {
			var position = ctrl.emails.map(function(email){
				return email.id;
			}).indexOf(data.id);
			ctrl.emails[position] = data;
		});
		var deleteListener = $rootScope.$on('EmailCtrl.destroy', function (event, data) {
			var position = ctrl.emails.map(function(email){
				return email.id;
			}).indexOf(data.object.id);
			ctrl.emails.splice(position,1);
		});
		
		$scope.$on('$destroy', function(){
			createListener();
			updateListener();
		});
	}
})();
(function(){
	'use strict';
	angular
	.module('myApp')
	.controller('HelpCtrl', HelpCtrl)
	HelpCtrl.$inject = [
		"$rootScope",
		"$scope",
		"HelpService",
		"$controller"
	];
	function HelpCtrl(
		$rootScope,
		$scope,
		HelpService,
		$controller
	){

		var ctrl = this;
		//Get the default functionality
		var base = $controller('BaseCtrl', { $scope: $scope });

		angular.extend(this, base)

		ctrl.columns 			= [
			{'class':'col-md-8','field':'title','title':'Title'},
			{'class':'col-md-3','field':'title','title':''},
			// {'class':'col-md-8','field':'created_at','title':'Created'}
		];

		ctrl.field = 'title';
		ctrl.isReverse = true;
		ctrl.itemsPerPage = 100;
		ctrl.amounts = [];
		ctrl.amount = {};
		ctrl.isTabulated = false;

		ctrl.getHelps = function(){
			HelpService.getAllHelps()
			.then(function(res){
				ctrl.helps = res.data;
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM getHelps: ", err);
			});
		}

		ctrl.getHelp = function(helpId){
			HelpService.getHelp(helpId)
			.then(function(res){
				ctrl.help = res;
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM getHelp: ", err);
			});
		}

		ctrl.searchHelps = function(){
			HelpService.searchHelps()
			.then(function(res){
				ctrl.helps = res;
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM searchHelps: ", err);
			});
		}

		ctrl.deleteHelp= function (helpId, idx){
			if(confirm('Are you sure you want to delete this help?')){
				HelpService.deleteHelp(helpId)
				.then(function(res){
					ctrl.helps.splice(idx, 1);
					ctrl.fireEvents(res);
				})
				.catch(function(err){
					console.error("ERROR RESPONDING FROM deleteHelp: ", err);
				});
			}
		}

		// Events Listener
		var createListener = $rootScope.$on('HelpCtrl.create', function (event, data) {
			ctrl.helps.push(data.payload);
		});
		var updateListener = $rootScope.$on('HelpCtrl.update', function (event, data) {
			// do nothing
		});
		var deleteListener = $rootScope.$on('HelpCtrl.destroy', function (event, data) {
			var position = ctrl.helps.map(function(help){
				return help.id;
			}).indexOf(data.object.id);
			ctrl.helps.splice(position,1);
		});

		$scope.$on('$destroy', function(){
			createListener();
			updateListener();
		});
	}
})();
(function(){
	'use strict';
	angular
	.module('myApp')
	.controller('HelpFormController', HelpFormController)
	HelpFormController.$inject = ['$rootScope',
		'$scope',
		'$uibModalInstance',
		'items',
		'HelpService',
		"$controller"
	];
	function HelpFormController(
		$rootScope,
		$scope,
		$uibModalInstance,
		items,
		HelpService,
		$controller){

		var ctrl = this;
		//Get the default functionality
		var base = $controller('BaseCtrl', {$scope: $scope});

		angular.extend(this, base)

		ctrl.hasError = false;
		ctrl.errors = [];
		ctrl.payload = items.payload;
		var expectEvent = items.expect;

		var originalObj = angular.extend({}, items.bind);

		ctrl.getHelps = function(bundleId){
			HelpService.getBundleHelps(bundleId)
			.then(function(res){
				ctrl.helps = res;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM getHelps: ", err);
			});
		};

		ctrl.addHelp = function(){
			var data = ctrl.bind
			HelpService.addHelp(data)
			.then(function(res){
				ctrl.helps.push(res);
				ctrl.fireEvents(res);
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM addHelp: ", err);
			});
		};

		ctrl.updateHelp = function(help){
			var data = ctrl.bind
			HelpService.updateHelp(ctrl.bind.bundleId, data)
			.then(function(res){
				ctrl.fireEvents(res);
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM updateHelp: ", err);
			});
		};

		ctrl.deleteHelp = function (helpId, idx){
			if(confirm('Are you sure you want to delete this help?')){
				HelpService.deleteHelp(helpId)
				.then(function(res){
					ctrl.helps.splice(idx, 1);
					ctrl.fireEvents(res);
				})
				.catch(function(err){
					console.error("ERROR RESPONDING FROM GET ALL USERS: ", err);
				});
			}
		};

		ctrl.fireEvents = function(d){
			if(expectEvent != undefined && expectEvent != ''){
				$rootScope.$emit(expectEvent, d);
			}else{
			}
		};

		ctrl.cancel = function () {
			if(ctrl.bind != undefined) {

			}

			$uibModalInstance.dismiss('cancel');
		};
	}
})();
(function(){
	'use strict';
	angular
	.module('myApp')
	.controller('ImportFormCtrl', ImportFormCtrl)
	ImportFormCtrl.$inject = [
		'$rootScope',
		'$scope',
		'$uibModalInstance',
		'items',
		'FileUploadService',
		"$controller"
	];
		function ImportFormCtrl(
			$rootScope,
			$scope,
			$uibModalInstance,
			items,
			FileUploadService,
			$controller
		){

			var ctrl = this;

			//Get the default functionality for modal form
			var base = $controller('BaseFormCtrl', {$scope: $scope});

			angular.extend(this, base);

			ctrl.uploadFile = function(){
				var actionUrl = $('#modalForm').attr('action');
				var file = ctrl.file;

				var fileUploadPromise = FileUploadService.uploadFileToUrl(file, actionUrl, ctrl.bind);

				fileUploadPromise
				.then(function(res) {
					if (expectEvent != undefined && expectEvent != '') {
						$rootScope.$emit(expectEvent, res);
					}
					$uibModalInstance.close('uploading...');
				})
				.catch(function(res) {
					if(res.status == 422) {
						$scope.notSubmitted = true;
						ctrl.notSubmitted = true;
						ctrl.processErrors(res.data)
						$rootScope.$emit('fileUploadError', res.data);
						ctrl.submitDisabled = false;
					}
					ctrl.hasError = true;
				});
				ctrl.pendingUpload = {};
				ctrl.pendingUpload.awaiting = fileUploadPromise;

				$rootScope.$emit('fileUpload', ctrl.pendingUpload);

				$uibModalInstance.close('uploading...');
				return;
			}

			ctrl.fireEvents = function (d) {
				if (ctrl.expectEvent != undefined && ctrl.expectEvent != '') {
					$rootScope.$emit(ctrl.expectEvent, d);
				} else {
					//
				}
			}

			$scope.ok = ctrl.uploadFile;

			$scope.cancel = function () {
				if(ctrl.bind != undefined) {
					// angular.extend(ctrl.bind, originalObj);
				}
				$uibModalInstance.dismiss('cancel');
			};
	}
})();
(function(){
	'use strict';
	angular
	.module('myApp')
	.controller('InvoiceCtrl', InvoiceCtrl)
	InvoiceCtrl.$inject = [
		"$rootScope",
		"$scope",
		"InvoiceService",
		"$controller"
	];
	function InvoiceCtrl(
		$rootScope,
		$scope,
		InvoiceService,
		$controller){

		var ctrl = this;
		//Get the default functionality
		var base = $controller('BaseCtrl', {$scope: $scope});

		angular.extend(this, base)

		ctrl.invoices			= [];
		ctrl.columns 			= [
			{'class':'col-md-6','field':'price','title':'Price'},
			{'class':'col-md-6','field':'total','title':'Total'},
			{'class':'col-md-6','field':'type','title':'Type'},
			{'class':'col-md-6','field':'quantity','title':'Quantity'},
			{'class':'col-md-6','field':'description','title':'Description'}
		];

		ctrl.modColumns 		= [
			{'class':'col-sm-2','field':'type','title':'Type'},
			{'class':'col-sm-2','field':'price','title':'Price'},
			{'class':'col-sm-2','field':'quantity','title':'Quantity'},
			{'class':'col-sm-3','field':'description','title':'Description'},
			{'class':'col-sm-2','field':'total','title':'Total'}
		];

		ctrl.getInvoices = function(){
			InvoiceService.getAllInvoices()
			.then(function(res){
				ctrl.invoices = res;
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM getInvoices: ", err);
			});
		}

		ctrl.getInvoice = function(invoiceId){
			InvoiceService.getInvoice(invoiceId)
			.then(function(res){
				ctrl.invoice = res;
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM getInvoices: ", err);
			});
		};

		ctrl.loadParentInvoices = function(parentId,parentType){
			ctrl.parentId = parentId;
			ctrl.parentIdType = parentType;
			InvoiceService.getAllInvoicesByParent(ctrl.parentId,ctrl.parentIdType)
			.then(function(res){
				ctrl.invoices = res;
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM getInvoices: ", err);
			});
		};

		ctrl.searchInvoices = function(){
			InvoiceService.searchInvoices()
			.then(function(res){
				ctrl.invoices = res;
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM getInvoices: ", err);
			});
		}

		ctrl.deleteInvoice= function (invoiceId, idx){
			if(confirm('Are you sure you want to delete this invoice?')){
				InvoiceService.deleteInvoice(invoiceId)
				.then(function(res){
					var position = ctrl.invoices.map(function(invoice){
						return invoice.id;
					}).indexOf(res.id);
					ctrl.invoices.splice(position,1);
				})
				.catch(function(err){
					console.error("ERROR RESPONDING FROM GET ALL USERS: ", err);
				});
			}
		}

		// Events Listener
		var createListener = $rootScope.$on('InvoiceCtrl.create', function (event, data) {
			ctrl.invoices.push(data.payload);
		});
		var updateListener = $rootScope.$on('InvoiceCtrl.update', function (event, data) {
			// do nothing
		});
		var deleteListener = $rootScope.$on('InvoiceCtrl.destroy', function (event, data) {
			var position = ctrl.invoices.map(function(invoice){
				return invoice.id;
			}).indexOf(data.object.id);
			ctrl.invoices.splice(position,1);
		});

		$scope.$on('$destroy', function(){
			createListener();
			updateListener();
		});
	}
})();
(function(){
	'use strict';
	angular
	.module('myApp')
	.controller('InvoiceFormController', InvoiceFormController)
	InvoiceFormController.$inject = [
		'$rootScope',
		'$scope',
		'$uibModalInstance',
		'items',
		'InvoiceService',
		"$controller"];
	function InvoiceFormController(
		$rootScope,
		$scope,
		$uibModalInstance,
		items,
		InvoiceService,
		$controller){

		var ctrl = this;
		//Get the default functionality
		var base = $controller('BaseCtrl', {$scope: $scope});

		angular.extend(this, base)

		ctrl.hasError = false;
		ctrl.errors = [];
		ctrl.payload = items.payload;
		var expectEvent = items.expect;

		var originalObj = angular.extend({}, items.bind);

		ctrl.getInvoices = function(bundleId){
			InvoiceService.getBundleInvoices(bundleId)
			.then(function(res){
				ctrl.invoices = res;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM getInvoices: ", err);
			});
		}

		ctrl.addInvoice = function(){
			var data = ctrl.bind
			InvoiceService.addInvoice(data)
			.then(function(res){
				ctrl.invoices.push(res);
				ctrl.fireEvents(res);
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM addInvoice: ", err);
			});
		}

		ctrl.updateInvoice = function(invoice){
			var data = ctrl.bind
			InvoiceService.updateInvoice(ctrl.bind.bundleId, data)
			.then(function(res){
				ctrl.fireEvents(res);
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM updateInvoice: ", err);
			});
		}

		ctrl.deleteInvoice = function(invoiceId, idx){
			var data = ctrl.bind
			InvoiceService.deleteInvoice(invoiceId)
			.then(function(res){
				ctrl.invoices.splice(idx, 1);
				ctrl.fireEvents(res);
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM deleteInvoice: ", err);
			});
		}

		ctrl.fireEvents = function(d){
			if(expectEvent != undefined && expectEvent != ''){
				$rootScope.$emit(expectEvent, d);
			}else{
			}
		}

		ctrl.cancel = function () {
			if(ctrl.bind != undefined) {
				// angular.extend(ctrl.bind, originalObj);
			}

			$uibModalInstance.dismiss('cancel');
		};
	}
})();
(function(){
	'use strict';
	angular
	.module('myApp')
	.controller('JournalCtrl', JournalCtrl)
	JournalCtrl.$inject = ['$rootScope',
		'$scope',
		'JournalService',
		"$controller"];
	function JournalCtrl($rootScope,
		$scope,
		JournalService,
		$controller
		){

		var ctrl = this;
		//Get the default functionality
		var base = $controller('BaseCtrl', {$scope: $scope});

		angular.extend(this, base)

		ctrl.pageSize = 5;

		//methods
		ctrl.loadParentJournals = function(parentId, parentType){
			ctrl.parentId = parentId;
			ctrl.parentType = parentType;
			JournalService.getAllJournalsByParent(ctrl.parentId,ctrl.parentType)
			.then(function(res){
				ctrl.journals = res;
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM getAllJournalsByParent: ", err);
			});
		};

		ctrl.togglePinned = function(journal){
			var data = {
				pinned:!journal.pinned
			}
			console.log('togglePinned data:',data);
			JournalService.updateJournal(journal.uid, data)
			.then(function(res){
				journal.pinned=res.pinned;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM getAllJournalsByParent: ", err);
			});
		};

		// Events Listener
		var createListener = $rootScope.$on('JournalCtrl.create', function (event, data) {
			ctrl.journals.unshift(data.payload);
		});

		var updateListener = $rootScope.$on('JournalCtrl.update', function (event, data) {
			//do nothing
		});

		var reloadListener = $rootScope.$on('JournalCtrl.reload', function (event, data) {
			ctrl.loadParentJournals(ctrl.parentId, ctrl.parentType);
		});

		//Events Listener
		$scope.$on('$destroy', function(){
			createListener();
			updateListener();
			reloadListener();
		});
	}
})();
(function(){
	'use strict';
	angular
	.module('myApp')
	.controller('LinkCtrl', LinkCtrl)
	LinkCtrl.$inject = ["$rootScope","$scope","$http","$filter","$uibModal","LinkService","RoleService","$controller","$controller"];
	function LinkCtrl($rootScope,$scope, $http, $filter, $uibModal, LinkService, RoleService, $controller){
		
		var ctrl = this;
		$scope.roles = [];
		//Get the default functionality
		var base = $controller('BaseCtrl', {$scope: $scope});

		angular.extend(this, base)

		//member data
		ctrl.links		= [],
		ctrl.converted_permissions = [],
		ctrl.roles		= [],
		ctrl.columns 		= [
			{'class':'col-md-3','field':'controller_method','title':'Controller@Method'},
			{'class':'col-md-2','field':'menu_item','title':'Nav Menu'},
			{'class':'col-md-2','field':'sequence','title':'Order'},
			{'class':'col-md-2','field':'default_link_text','title':'Link Text'}
		]

		//methods
		ctrl.loadPageLinks = function(){
			ctrl.isLoaded = false;
			LinkService.getSessionLinks()
			.then(function(res){
				angular.forEach(res, function(link){
					ctrl.links.push(link);
				});
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM getSessionLinks: ", err); 
			});
		}
		ctrl.loadLinks = function(){
			ctrl.isLoaded = false;
			LinkService.getAllLinks()		
			.then(function(res){
				ctrl.links = res;
				ctrl.loadRoles();
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM getAllLinks: ", err); 
			});
		}

		ctrl.loadRoles = function(){
			ctrl.isLoaded = false;
			RoleService.getAllRoles()
			.then(function(res){
				ctrl.roles = res;
				$scope.roles = ctrl.roles;
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM getAllRoles: ", err); 
			});
		};

		ctrl.deleteLink= function (id,idx){
			if(confirm('Are you certain you want to delete this link?'))
			{
				LinkService.deleteLink(id)
				.then(function(res){
					ctrl.addresses.splice(idx, 1);
				})
				.catch(function(err){
					console.error("ERROR RESPONDING FROM deleteLink: ", err); 
				});
			}
		}

		ctrl.changeLinkPermission = function (role,link){
			var permission = link.permissions[role.name] ? true : false;
			var post_data = {
				'link_id': link.id,
				'role_id': role.id,
			};
			
			// if this is true, we should be removing it
			if(permission){
				LinkService.detachRole(post_data)
				.then(function(res){
					link.permissions[role.name] = false;
				})
				.catch(function(err){
					console.error("ERROR RESPONDING FROM attachRole: ", err);
					link.permissions[role.name] = true; 
				});
			}else{
				LinkService.attachRole(post_data)
				.then(function(res){
					link.permissions[role.name] = true;
				})
				.catch(function(err){
					console.error("ERROR RESPONDING FROM attachRole: ", err);
					link.permissions[role.name] = false;
				});
			}
		};

		// Events Listener
		var createListener = $rootScope.$on('LinkCtrl.create', function (event, data) {
			ctrl.links.push(data.payload);
		});
		var updateListener = $rootScope.$on('LinkCtrl.update', function (event, data) {
			//do nothing
		});

		$scope.$on('$destroy', function(){
			createListener();
			updateListener();
		});
	}
})();
(function(){
	'use strict';
	angular
	.module('myApp')
	.controller('LinkFormController', LinkFormController)
	LinkFormController.$inject = [
		'$rootScope',
		'$scope',
		'$uibModalInstance',
		'items',
		'LinkService',
		'LinkattrService',
		"$controller"
	];
	function LinkFormController(
		$rootScope,
		$scope,
		$uibModalInstance,
		items,
		LinkService,
		LinkattrService,
		$controller){

		var ctrl = this;
		//Get the default functionality
		var base = $controller('BaseCtrl', {$scope: $scope});

		angular.extend(this, base)

		ctrl.bind = items.bind;

		ctrl.hasError = false;
		ctrl.errors = [];
		ctrl.attrs = [];
		ctrl.payload = items.payload;
		var expectEvent = items.expect;

		var originalObj = angular.extend({}, items.bind);

		ctrl.getLinks = function(){
			LinkService.getLinks()
			.then(function(res){
				ctrl.links = res;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM getLinks: ", err);
			});
		};

		ctrl.getLink = function(Id){
			LinkService.getLink(Id)
			.then(function(res){
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM getLink: ", err);
			});
		};

		ctrl.addLink = function(){
			var data = ctrl.bind
			LinkService.addLink(data)
			.then(function(res){
				ctrl.links.push(res);
				ctrl.fireEvents(expectEvent);
				$uibModalInstance.close(ctrl.bind);
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM addLink: ", err);
			});
		};

		ctrl.updateLink = function(){
			var data = ctrl.bind;
			LinkService.updateLink(data.id, data)
			.then(function(res){
				ctrl.link = res;
				ctrl.fireEvents(expectEvent);
				$uibModalInstance.close(ctrl.bind);
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM updateLink: ", err);
			});
		};

		ctrl.deleteLink = function(linkId, idx){
			var data = ctrl.bind
			LinkService.deleteLink(linkId)
			.then(function(res){
				ctrl.links.splice(idx, 1);
				ctrl.fireEvents(expectEvent);
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM deleteLink: ", err);
			});
		};

		ctrl.getAttributes = function(linkId){
			LinkattrService.getAllLinkattrsByParent(linkId)
			.then(function(res){
				ctrl.attrs = res;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM getAttributes: ", err);
			});
		};

		ctrl.addParent = function(item){
		};

		ctrl.addAttribute = function(){
			var data = {
				'name':ctrl.newName,
				'value':ctrl.newValue,
				'link_id':ctrl.link.id
			}
			LinkattrService.addLinkattr(data)
			.then(function(res){
				ctrl.attrs.push(res);
				ctrl.newName = '';
				ctrl.newValue = '';
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM addAttribute: ", err);
			});
		};

		ctrl.deleteAttribute = function(linkattrId, idx){
			if(confirm('Are you sure you want to remove this attribute?')){
				LinkattrService.deleteLinkattr(linkattrId)
				.then(function(res){
					ctrl.attrs.splice(idx, 1);
					return false;
				})
				.catch(function(err){
					console.error("ERROR RESPONDING FROM GET ALL Links: ", err);
				});
			}
		};

		ctrl.fireEvents = function(d){
			if(expectEvent != undefined && expectEvent != ''){
				$rootScope.$emit(expectEvent, d);
			}else{
			}
		};

		ctrl.cancel = function () {
			if(ctrl.bind != undefined) { }

			$uibModalInstance.dismiss('cancel');
		};

		$scope.$watchGroup(['bind.id'],function(o,n){
			ctrl.link = ctrl.bind;
			ctrl.getAttributes(ctrl.bind.id);
		});

	}
})();
(function(){
	'use strict';
	angular
	.module('myApp')
	.controller('MediaCtrl', MediaCtrl)
	MediaCtrl.$inject = [
		"$rootScope",
		"$scope",
		"$uibModalInstance",
		"AttachmentService",
		"$controller",
		"$sce"
	];
	function MediaCtrl(
		$rootScope,
		$scope,
		$uibModalInstance,
		AttachmentService,
		$controller,
		$sce
	){
		var ctrl = this;

		//Get the default functionality
		var base = $controller('BaseCtrl', {$scope: $scope});

		angular.extend(this, base)

		ctrl.columns = [
			{'class':'col-md-2','field':'attachment_date','title':'Bar Date'},
			{'class':'col-md-8','field':'description','title':'Description'}
		];
		ctrl.orderField = ctrl.columns[0];
		ctrl.attachments = [];
		ctrl.attachment = {};

		ctrl.sources = []

		ctrl.showLoaded = function(){
			alert('Loaded, suck it.');
		}

		// get a specific Attachment
		ctrl.getAttachment = function(attachmentId){
			AttachmentService.getAttachment(attachmentId)
			.then(function(res){
				ctrl.attachment = res;
				var mediaType = "audio/mpeg";
				if(res.media_type =='video'){
					mediaType = "video/mp4";
				}
				var source = {src: $sce.trustAsResourceUrl(res.presignedUrl), type: mediaType}
				ctrl.sources.push(source);
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM getAttachments: ", err); 
			});
		}


		// Events Listeners
		var createListener = $rootScope.$on('MediaCtrl.create', function (event, data) {
			ctrl.attachments.push(data.payload);
		});

		var updateListener = $rootScope.$on('MediaCtrl.update', function (event, data) {
			var position = ctrl.attachments.map(function(attachment){
				return attachment.id;
			}).indexOf(data.id);
			ctrl.attachments[position] = data;
		});

		var deleteListener = $rootScope.$on('MediaCtrl.destroy', function (event, data) {
			var position = ctrl.attachments.map(function(attachment){
				return attachment.id;
			}).indexOf(data.object.id);
			ctrl.attachments.splice(position,1);
		});
		
		$scope.$on('$destroy', function(){
			createListener();
			updateListener();
		});

		$scope.cancel = function () {
			if($scope.bind != undefined) {
				angular.extend($scope.bind, originalObj);
			}
			
			$uibModalInstance.dismiss('cancel');
		};
	}
})();
(function(){
	'use strict';
	angular
	.module('myApp')
	.controller('MessageCtrl', MessageCtrl)
	MessageCtrl.$inject = ["$rootScope","$scope","$http","$filter","$uibModal","MessageService","$controller"];
	function MessageCtrl($rootScope,$scope, $http, $filter, $uibModal, MessageService, $controller){

		var ctrl = this;
		//Get the default functionality
		var base = $controller('BaseCtrl', {$scope: $scope});

		angular.extend(this, base)

		 //methods
		ctrl.loadParentMessage = function(parentId, parentType){
			ctrl.parentId = parentId;
			ctrl.parentType = parentType;
			MessageService.getAllMessagesByParent(ctrl.parentId,ctrl.parentType)
			.then(function(res){
				ctrl.messages = res;
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM getAllMessagesByParent: ", err);
			});
		};

		ctrl.deleteMessage = function (id,idx){
			if(confirm('Are you certain you want to delete this message?'))
			{
				MessageService.deleteMessage(id)
				.then(function(res){
					ctrl.messages.splice(idx, 1);
				})
				.catch(function(err){
					console.error("ERROR RESPONDING FROM deleteMessage: ", err);
				});
			}
		};

		// Events Listener
		var createListener = $rootScope.$on('MessageCtrl.create', function (event, data) {
			ctrl.messages.push(data.payload);
		});

		var updateListener = $rootScope.$on('MessageCtrl.update', function (event, data) {
			ctrl.loadMessages(ctrl.parentId,ctrl.parentType);
		});

		var reloadListener = $rootScope.$on('MessageCtrl.reload', function (event, data) {
			ctrl.loadMessages(ctrl.parentId,ctrl.parentType);
		});

		var deleteListener = $rootScope.$on('MessageCtrl.delete', function (event, data) {

		});

		//Events Listener
		$scope.$on('$destroy', function(){
			createListener();
			updateListener();
			reloadListener();
		});
	}
})();
(function () {
	'use strict';
	angular
		.module('myApp')
		.controller('MilestoneCtrl', MilestoneCtrl)
	MilestoneCtrl.$inject = ["$rootScope",
		"$scope",
		"MilestoneService",
		"UserService",
		"$controller"
	];
	function MilestoneCtrl($rootScope,
		$scope,
		MilestoneService,
		UserService,
		$controller) {

		var ctrl = this;
		var base = $controller('BaseCtrl', { $scope: $scope });
		angular.extend(this, base)

		ctrl.columns = [
			{ 'class': 'col-md-4', 'field': 'type', 'title': 'Type' },
			{ 'class': 'col-md-4', 'field': 'name', 'title': 'Name' },
			{ 'class': 'col-md-4', 'field': 'sequence', 'title': 'Order' },
		];

		ctrl.loadParentMilestones = function (parentId, parentType) {
			ctrl.parentId = parentId;
			ctrl.parentType = parentType;
			MilestoneService.getAllMilestonesByParent(parentId, parentType)
				.then(function (res) {
					ctrl.milestones = res;
					ctrl.isLoaded = true;
				})
				.catch(function (err) {
					console.error("ERROR RESPONDING FROM getMilestones: ", err);
				});
		};

		ctrl.loadMilestones = function () {
			MilestoneService.getAllMilestones()
				.then(function (res) {
					ctrl.milestones = res;
					ctrl.isLoaded = true;
				})
				.catch(function (err) {
					console.error("ERROR RESPONDING FROM getMilestones: ", err);
				});
		};

		ctrl.loadUser = function () {
			UserService.getUsersLookup()
				.then(function (res) {
					ctrl.users = res;
					ctrl.isLoaded = true;
				})
				.catch(function (err) {
					console.error("ERROR RESPONDING FROM getMilestones: ", err);
				});
		};

		ctrl.getMilestones = function () {
			MilestoneService.getAllMilestones()
				.then(function (res) {
					ctrl.milestones = res;
					ctrl.isLoaded = true;
				})
				.catch(function (err) {
					console.error("ERROR RESPONDING FROM getMilestones: ", err);
				});
		};

		ctrl.getMiletone = function (milestoneId) {
			MilestoneService.getMilestone(milestoneId)
				.then(function (res) {
					ctrl.milestone = res;
					ctrl.isLoaded = true;
				})
				.catch(function (err) {
					console.error("ERROR RESPONDING FROM getMilestones: ", err);
				});
		};

		ctrl.searchMilestones = function () {
			MilestoneService.searchMilestones()
				.then(function (res) {
					ctrl.milestones = res;
					ctrl.isLoaded = true;
				})
				.catch(function (err) {
					console.error("ERROR RESPONDING FROM getMilestones: ", err);
				});
		};

		ctrl.deleteMilesone = function (milestoneId, idx) {
			if (confirm('Are you sure you want to delete this milestone?')) {
				MilestoneService.deleteMilestone(milestoneId)
					.then(function (res) {
						ctrl.milestones.splice(idx, 1);
					})
					.catch(function (err) {
						console.error("ERROR RESPONDING FROM GET ALL USERS: ", err);
					});
			}
		};

		ctrl.logMilestone = function (milestone, idx) {
			var data = {
				'milestonable_id': ctrl.parentId,
				'milestonable_type': ctrl.parentType,
				'milestone_id': milestone.id,
			}
			MilestoneService.logMilestone(data)
				.then(function (res) {
					milestone.milestonable_id = ctrl.parentId;
					milestone.pivot = res.pivot;
					$rootScope.$emit('ChangeCtrl.reload');
				})
				.catch(function (res) {
					console.error("ERROR RESPONDING FROM logMilestone: ", err);
				});
		};

		ctrl.unlogMilestone = function (milestone, idx) {
			var data = {
				'milestonable_id': ctrl.parentId,
				'milestonable_type': ctrl.parentType,
				'milestone_id': milestone.id,
			}
			MilestoneService.unlogMilestone(data)
				.then(function (res) {
					milestone.milestonable_id = null;
					milestone.pivot = null;
					$rootScope.$emit('ChangeCtrl.reload');
				})
				.catch(function (res) {
					console.error("ERROR RESPONDING FROM unlogMilestone: ", err);
				});
		};

		// Events Listener
		var createListener = $rootScope.$on('MilestoneCtrl.create', function (event, data) {
			ctrl.milestones.push(data.payload);
		});
		var updateListener = $rootScope.$on('MilestoneCtrl.update', function (event, data) {
			// do nothing
		});
		var deleteListener = $rootScope.$on('MilestoneCtrl.destroy', function (event, data) {
			var position = ctrl.milestones.map(function (milestone) {
				return milestone.id;
			}).indexOf(data.object.id);
			ctrl.milestones.splice(position, 1);
		});

		$scope.$on('$destroy', function () {
			createListener();
			updateListener();
		});
	}
})();
(function(){
	'use strict';
	angular
	.module('myApp')
	.controller('MilestoneFormController', MilestoneFormController)
	MilestoneFormController.$inject = [
		'$rootScope',
		'$scope',
		'$uibModalInstance',
		'items',
		'MilestoneService',
		"$controller"
	];
		function MilestoneFormController(
			$rootScope,
			$scope,
			$uibModalInstance,
			items,
			MilestoneService,
			$controller){

			var ctrl = this;
			//Get the default functionality
			var base = $controller('BaseCtrl', {$scope: $scope});

			angular.extend(this, base)

			ctrl.hasError = false;
			ctrl.errors = [];
			ctrl.payload = items.payload;
			var expectEvent = items.expect;

			var originalObj = angular.extend({}, items.bind);

			ctrl.getMilestones = function(bundleId){
				MilestoneService.getBundleMilestones(bundleId)
				.then(function(res){
					ctrl.milestones = res;
				})
				.catch(function(err){
					console.error("ERROR RESPONDING FROM getMilestones: ", err);
				});
			}

			ctrl.addMilestone = function(){
				var data = ctrl.bind
				MilestoneService.addMilestone(data)
				.then(function(res){
					ctrl.milestones.push(res);
					ctrl.fireEvents(res);
				})
				.catch(function(err){
					console.error("ERROR RESPONDING FROM addMilestone: ", err);
				});
			}

			ctrl.updateMilestone = function(milestone){
				var data = ctrl.bind
				MilestoneService.updateMilestone(ctrl.bind.bundleId, data)
				.then(function(res){
					ctrl.fireEvents(res);
				})
				.catch(function(err){
					console.error("ERROR RESPONDING FROM updateMilestone: ", err);
				});
			}

			ctrl.deleteMilestone = function (milestoneId, idx){
				if(confirm('Are you sure you want to delete this milestone?')){
					MilestoneService.deleteMilestone(milestoneId)
					.then(function(res){
						ctrl.milestones.splice(idx, 1);
						ctrl.fireEvents(res);
					})
					.catch(function(err){
						console.error("ERROR RESPONDING FROM GET ALL USERS: ", err);
					});
				}
			}

			ctrl.fireEvents = function(d){
				if(expectEvent != undefined && expectEvent != ''){
					$rootScope.$emit(expectEvent, d);
				}else{
				}
			}

			ctrl.cancel = function () {
				if(ctrl.bind != undefined) { }

				$uibModalInstance.dismiss('cancel');
		};
	}
})();
(function() {
	'use strict';
	angular
	.module('myApp')
	.controller('ModalInstanceController', ModalInstanceController)
	ModalInstanceController.$inject = [
		'$rootScope',
		'$scope',
		'$window',
		'$http',
		'$uibModalInstance',
		'items',
		'FileUploadService',
		"$controller"
	];
	function ModalInstanceController(
		$rootScope,
		$scope,
		$window,
		$http,
		$uibModalInstance,
		items,
		FileUploadService,
		$controller
	 ) {

		var ctrl = this;
		//Get the default functionality
		var base = $controller('BaseFormCtrl', {$scope: $scope});

		angular.extend(this, base)

		ctrl.hasError = false;
		ctrl.errors = [];
		ctrl.files = [];
		$scope.notSubmitted = true;
		ctrl.notSubmitted = true;
		ctrl.payload = items.payload;
		ctrl.toolbarButtons = [
			['h1', 'h2', 'h3', 'h4', 'p', 'quote'],
			['bold', 'italics', 'underline', 'strikeThrough', 'ul', 'ol', 'redo', 'undo', 'clear'],
			['justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull', 'indent', 'outdent'],
			['html', 'insertImage','insertLink', 'insertVariable', 'wordcount', 'charcount']
		];
		ctrl.froalaOptions = {
			// key: "what is it",
			toolbarButtons: ['paragraphFormat', 'bold', 'italic', 'underline', '|', 'align', 'formatOL', 'formatUL', 'insertLink', 'insertImage', 'insertVideo', 'embedly', '|', 'insertHR', 'clearFormatting', '|', 'help', 'html', '|', 'undo', 'redo'],
			attribution: false,
		}

		ctrl.addFile = function(files) {
			// fd.append("file", files[0]);
			$scope.files.push(files[0]);
		};

		ctrl.placeholder ='';

		ctrl.setFroalaOptions = function (key, token) {
			ctrl.froalaOptions.key = key;
			var UploadParams = {
				_token: token
			}
			ctrl.froalaOptions.videoUploadParams = UploadParams;
			ctrl.froalaOptions.imageUploadParams = UploadParams;
			ctrl.froalaOptions.fileUploadParams = UploadParams;
		};

		ctrl.getCursorPosition = function() {
			if(ctrl.placeholder) {
				var sel, range;
				sel = window.getSelection();
				if (sel.getRangeAt && sel.rangeCount) {
					vm.rango = sel.getRangeAt(0);
					vm.rango.insertNode(document.createTextNode('{'+ctrl.placeholder+'}'));
					ctrl.placeholder = '';

					return sel.getRangeAt(0);
				}
			}
		}

		// ctrl.hasError = function(field){
		// 	// return typeof ctrl.errors[field] != 'undefined' ? 'has-error' : '';
		// }

		ctrl.getError = function(field){
			var err = ctrl.errors[field];
			if(typeof err != 'undefined'){
				return err.join();
			}
		}

		var expectEvent = items.expect;
		if(items.bind != undefined) {
			$scope.bind = items.bind;
			ctrl.bind = $scope.bind;
		} else {
			$scope.bind = {};
			ctrl.bind = $scope.bind;
		}
		console.log('gtrl.bind',ctrl.bind);
		console.log('$scope.bind',$scope.bind);
		var url = items.url;
		var str = url.substr(url.lastIndexOf('/'));
		var newUrl = url.replace(new RegExp(str), '');

		var actionUrl = (items.action != undefined) ? items.action : newUrl;

		var originalObj = angular.extend({}, items.bind);
		var hasQueryStr = actionUrl.search('\\?');
		if(hasQueryStr != -1) {
			actionUrl = actionUrl.substr(0,hasQueryStr);
		}
		var hasCreate = actionUrl.search('/create');
		if(hasCreate != -1) {
			actionUrl = actionUrl.substr(0, hasCreate);
		}

		if(items.isFile != undefined) {
		}


		ctrl.ok = function () {
			$scope.notSubmitted = false;
			ctrl.notSubmitted = false;
			ctrl.errors = [];
			ctrl.hasError = false;
			var formAction = $('#modalForm').attr('action');

			// we should use the action from the form if it is set
			actionUrl = (formAction != undefined) ? formAction : newUrl;

			if(items.isFile != undefined) {
				actionUrl = (formAction != undefined) ? formAction : newUrl;
				var file = ctrl.file;
				console.log('ok ctrl.file: ',ctrl.file);

				var fileUploadPromise = FileUploadService.uploadFileToUrl(file, actionUrl, ctrl.bind);

				fileUploadPromise
				.then(function(res) {
					if (expectEvent != undefined && expectEvent != '') {
						$rootScope.$emit(expectEvent, res);
					}
					$uibModalInstance.close('uploading...');
				})
				.catch(function(res) {
					if(res.status == 422) {
						$scope.notSubmitted = true;
						ctrl.notSubmitted = true;
						ctrl.processErrors(res.data)
						$rootScope.$emit('fileUploadError', res.data);
						ctrl.submitDisabled = false;
					}
					ctrl.hasError = true;
				});
				var pendingUpload = ctrl.bind;
				pendingUpload.awaiting = fileUploadPromise;
				pendingUpload.id = ctrl.bind.upload_id;
				pendingUpload.name = ctrl.bind.description;

				$rootScope.$emit('fileUpload', pendingUpload);

				$uibModalInstance.close('uploading...');
				return;
			}
			if($scope.bind.id != undefined) {
				if(items.action == 'delete') {
					actionUrl = newUrl;
					$http.delete(actionUrl)
					.then(function (d) {
						if (expectEvent != undefined && expectEvent != '') {
							$rootScope.$emit(expectEvent, d);
						}
						$uibModalInstance.close(d);
					})
					.catch(function (d) {
						if(d.status == 422) {
							$scope.notSubmitted = true;
							ctrl.notSubmitted = true;
							ctrl.processErrors(d.data)
						} else if(d.message != undefined) {
							ctrl.errors.push(d.message)
						} else {
							ctrl.errors.push("An Error occurred");
						}
						ctrl.hasError = true;
					});
				} else {
					$http.put(actionUrl, ctrl.bind)
					.then(function(res) {
						var d = res.data;
						if(d.success) {
							if(expectEvent != undefined && expectEvent != '') {
								$rootScope.$emit(expectEvent, d);
							}
							if(d.redirect != undefined) {
								$window.location.href = d.redirect;
							}
							$uibModalInstance.close(ctrl.bind);
						} else {
							if(d.status == 422) {
								$scope.notSubmitted = true;
								ctrl.notSubmitted = true;

								ctrl.processErrors(d.data)
							} else if(d.message != undefined) {
								ctrl.errors.push(d.message)
							} else {
								ctrl.errors.push("An Error occurred");
							}
							ctrl.hasError = true;
						}
					})
					.catch(function(d) {
						if(d.status == 422) {
							$scope.notSubmitted = true;
							ctrl.notSubmitted = true;
							ctrl.processErrors(d.data)
						} else if(d.message != undefined) {
							ctrl.errors.push(d.message)
						} else {
							ctrl.errors.push("An Error occurred");
						}
						ctrl.hasError = true;
					});
				}
			} else {
				actionUrl = (formAction != undefined) ? formAction : newUrl;
				$http.post(actionUrl, ctrl.bind)
				.then(function(res) {
					var d = res.data;
					if(d.success)
					{
						if(expectEvent != undefined && expectEvent != '') {
							$rootScope.$emit(expectEvent, d);
						}
						if(d.redirect != undefined) {
							$window.location.href = d.redirect;
						}
						$uibModalInstance.close(ctrl.bind);
					} else {
						if(d.status == 422) {
							$scope.notSubmitted = true;
							ctrl.notSubmitted = true;
							ctrl.processErrors(d.data)
						} else if(d.message != undefined) {
							ctrl.errors.push(d.message)
						} else {
							ctrl.errors.push("An Error occurred");
						}
						ctrl.hasError = true;
					}
				})
				.catch(function(d) {
					if(d.status == 422) {
						$scope.notSubmitted = true;
						ctrl.notSubmitted = true;
						ctrl.processErrors(d.data)
					} else if(d.message != undefined) {
						ctrl.errors.push(d.message)
					} else {
						ctrl.errors.push("An Error occurred");
					}
					ctrl.hasError = true;
				});
			}
		};

		ctrl.processErrors = function(res) {
			angular.forEach(res.errors, function(value, key) {
				angular.forEach(value, function(message, idx) {
					ctrl.errors.push(message);
				});
			});
			ctrl.hasError = true;
		};

		ctrl.cancel = function () {
			if(ctrl.bind != undefined) {
				angular.extend(ctrl.bind, originalObj);
			}
			$uibModalInstance.dismiss('cancel');
		};
		$scope.ok = ctrl.ok;
		$scope.cancel = ctrl.cancel;
	}
})();

(function () {
	'use strict';
	angular
		.module('myApp')
		.controller('MvmntUserCtrl', MvmntUserCtrl)
		MvmntUserCtrl.$inject = [
		"$rootScope",
		"$scope",
		"MVMNTUserService",
		"RoleService",
		"$controller"
	];
	function MvmntUserCtrl(
		$rootScope,
		$scope,
		MVMNTUserService,
		RoleService,
		$controller
	) {

		var ctrl = this;

		//Get the default functionality
		var base = $controller('BaseCtrl', { $scope: $scope });

		angular.extend(this, base)

		//member data
		ctrl.roles = [],
			ctrl.columns = [
			{ 'class': 'col-sm-2', 'field': 'fullname', 'title': 'Name' },
			{ 'class': 'col-sm-2', 'field': 'email', 'title': 'Email' },
			{ 'class': 'col-sm-2', 'field': 'mobile_number', 'title': 'Mobile' },
			{ 'class': 'col-sm-4', 'field': 'created_at', 'title': 'Registered Date' }
		];
		ctrl.modColumns = [
			{ 'class': 'col-sm-2', 'field': 'fullname', 'title': 'Name' },
			{ 'class': 'col-sm-2', 'field': 'email', 'title': 'Email' },
			{ 'class': 'col-sm-2', 'field': 'mobile_number', 'title': 'Mobile' },
			{ 'class': 'col-sm-4', 'field': 'created_at', 'title': 'Registered Date' }
		];
		ctrl.isTabulated = true;
		ctrl.showSearch = true;

		//methods
		ctrl.loadUsers = function () {
			ctrl.isLoaded = false;
			MVMNTUserService.getAllUsers()
				.then(function (res) {
					ctrl.users = res.data;
					ctrl.userCount = res.count;
					ctrl.loadRoles();
					ctrl.isLoaded = true;
				})
				.catch(function (err) {
					console.error("ERROR RESPONDING FROM getDepartments: ", err);
				});
		}

		ctrl.loadUser = function (userId) {
			ctrl.userId = userId;
			MVMNTUserService.getUser(ctrl.userId)
				.then(function (res) {
					ctrl.user = res;
					ctrl.isLoaded = true;
				})
				.catch(function (err) {
					console.error("ERROR RESPONDING FROM getUser: ", err);
				});
		};

		// get all Users for a specific parent
		ctrl.getUsersModule = function(parentId,parentType){
			ctrl.parentId = parentId;
			ctrl.parentType = parentType;
			MVMNTUserService.getAllUsersByParent(parentId,parentType)
			.then(function(res){
				ctrl.users = res;
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM getUsers: ", err);
			});
		}

		ctrl.loadRoles = function () {
			ctrl.isLoaded = false;
			RoleService.getAllRoles()
				.then(function (res) {
					ctrl.roles = res;
				})
				.catch(function (err) {
					console.error("ERROR RESPONDING FROM getDepartments: ", err);
				});
		}
		// Search all Donors
		ctrl.searchUsers = function () {
			MVMNTUserService.getAllUsers(ctrl.searchDB)
				.then(function (res) {
					ctrl.users = res.data;
					ctrl.userCount = res.count;
					ctrl.searchQry.$ = '';
					ctrl.isLoaded = true;
				})
				.catch(function (err) {
					console.error("ERROR RESPONDING FROM searchUsers: ", err);
				});
		}


		ctrl.deleteUser = function (user) {
			if (confirm('Are you certain you want to delete this user?')) {
				MVMNTUserService.deleteUser(user.uid)
					.then(function (res) {
						var position = ctrl.users.map(function(user){
							return user.id;
						}).indexOf(res.id);
						ctrl.users.splice(position, 1);
					})
					.catch(function (err) {
						console.error("ERROR RESPONDING FROM deleteUser: ", err);
					});
			}
		}

		ctrl.changeUserPermission = function (role, user) {

			var permission = user.permissions[role.name] ? false : true;

			var post_data = {
				'user_id': user.id,
				'role_id': role.id,
			};
			// if this is true, we should be removing it
			if (!permission) {
				MVMNTUserService.detachRole(post_data)
					.then(function (res) {
						user.permissions[role.name] = false;
					})
					.catch(function (err) {
						console.error("ERROR RESPONDING FROM attachRole: ", err);
						user.permissions[role.name] = true;
					});
			} else {
				MVMNTUserService.attachRole(post_data)
					.then(function (res) {
						user.permissions[role.name] = true;
					})
					.catch(function (err) {
						console.error("ERROR RESPONDING FROM attachRole: ", err);
						user.permissions[role.name] = false;
					});
			}
		};

		// delete a specific Engagement
		ctrl.remove = function (user, parentId, parentType){
			if(confirm('Are you sure you want to remove this user?')){
				var data = {
					parentId:parentId,
					parentType:parentType,
					userId:user.id,
				};
				// return
				MVMNTUserService.detachUserFromParent(data)
				.then(function(res){
					var position = ctrl.users.map(function(user){
						return user.id;
					}).indexOf(res.id);
					ctrl.users.splice(position, 1);
				})
				.catch(function(err){
					console.error("ERROR RESPONDING FROM GET ALL USERS: ", err);
				});
			}
		}
		// Events Listener
		var createListener = $rootScope.$on('MvmntUserCtrl.create', function (event, data) {
			ctrl.users.push(data.payload);
		});
		var updateListener = $rootScope.$on('MvmntUserCtrl.update', function (event, data) {
			//do nothing
		});
		var deleteListener = $rootScope.$on('MvmntUserCtrl.delete', function (event, data) {
			var position = ctrl.users.map(function(user){
				return user.id;
			}).indexOf(data.id);
			ctrl.users.splice(position, 1);
		});
		var reloadListener = $rootScope.$on('MvmntUserCtrl.reload', function (event, data) {
			ctrl.loadUser(ctrl.userId);
		});

		$scope.$on('$destroy', function () {
			createListener();
			updateListener();
		});
	}
})();
(function(){
	'use strict';
	angular
	.module('myApp')
	.controller('NavigationManagerController', NavigationManagerController)
	NavigationManagerController.$inject = [
		"$rootScope",
		"$scope",
		"RoleService",
		"LinkService",
		"$controller"
	];
	function NavigationManagerController(
		$rootScope,
		$scope,
		RoleService,
		LinkService,
		$controller
		){

		var ctrl = this;
		//Get the default functionality
		var base = $controller('BaseCtrl', {$scope: $scope});

		angular.extend(this, base)

		//member data
		ctrl.navigations 		= [],
		// roles			= [],
		ctrl.newNavigations	= {},
		ctrl.searchQry		= {},
		ctrl.isCollapsed 		= true,
		ctrl.treeNav 			= {}

		ctrl.loadRoles = function(){
			ctrl.isLoaded = false;
			if((ctrl.roles === undefined)||(ctrl.roles.length == 0)){
				RoleService.getAllRoles()
				.then(function(res){
					ctrl.roles = res;
					ctrl.isLoaded = true;
				})
				.catch(function(err){
					console.error("ERROR RESPONDING FROM loadRoles: ", err);
				});
			}
		};

		ctrl.loadMenuItems = function () {
			LinkService.getNavigation()
				.then(function (res) {
					ctrl.navigations = res;
					ctrl.isLoaded = true;
				})
				.catch(function (err) {
					console.error("ERROR RESPONDING FROM getNavMenu: ", err);
				});
		}

		ctrl.updateNav = function () {
			LinkService.updateNavigation(ctrl.navigations)
				.then(function (res) {
					ctrl.isLoaded = true;
					alert('Navigation saved');
				})
				.catch(function (err) {
					console.error("ERROR RESPONDING FROM getNavMenu: ", err);
				});
		}


		ctrl.treeNav = function(sourceNodeScope, destNodesScope, destIndex){
		}

		ctrl.treeOptions = {
			beforeDrop: function (event) {
				return true;
			},
			dropped: function (event) {
				return true;
			},
		};

		var createListener = $rootScope.$on('NavigationManagerController.create', function (event, data) {
			if(data.object.menu_item > 0 ){
				ctrl.navigations = ctrl.navigations.push(data.payload);
			}
		});
		var updateListener = $rootScope.$on('NavigationManagerController.update', function (event, data)
		{
		});
		var destroyListener = $rootScope.$on('NavigationManagerController.destroy', function (event, data)
		{
		});
		var deleteListener = $rootScope.$on('NavigationManagerController.delete', function (event, data)
		{
		});
	}
})();

(function(){
	'use strict';
	angular
	.module('myApp')
	.controller('NavigationCtrl', NavigationCtrl)
	NavigationCtrl.$inject = [
		"$rootScope",
		"$scope",
		"LinkService",
		"$controller"
	];
	function NavigationCtrl(
		$rootScope,
		$scope,
		LinkService,
		$controller){

		var ctrl = this;
		//Get the default functionality
		var base = $controller('BaseCtrl', {$scope: $scope});

		angular.extend(this, base)

		//member data
		ctrl.columns 			= [
			{'class':'col-sm-2','field':'name','title':'Name'},
			{'class':'col-sm-2','field':'filename','title':'Filename'},
			{'class':'col-sm-2','field':'description','title':'Description'}
		]

		//methods
		ctrl.loadMenuItems = function(){
			LinkService.getNavMenu()
			.then(function(res){
				ctrl.menuItems = res;
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM getNavMenu: ", err);
			});
		}

		ctrl.metisIt = function(){
			$('#side-menu').metisMenu();
		}

		var createListener = $rootScope.$on('NavigationCtrl.create', function (event, data) {
			if(data.object.menu_item > 0 ){
				ctrl.menuItems = ctrl.menuItems.push(data.payload);
			}
		});
		var updateListener = $rootScope.$on('NavigationCtrl.update', function (event, data) { });
		var destroyListener = $rootScope.$on('NavigationCtrl.destroy', function (event, data) { });
		var deleteListener = $rootScope.$on('NavigationCtrl.delete', function (event, data) {
			for(var i=0;i < ctrl.menuItems.length; i++)
			{
				if(data.object.id == ctrl.menuItems[i].id){
					if(!data.object.menu_item){
						ctrl.menuItems.splice(i,1); }
				}
			}
		});
	}
})();

(function(){
	'use strict';
	angular
	.module('myApp')
	.controller('NoticeCtrl', NoticeCtrl)
	NoticeCtrl.$inject = [
		'$rootScope',
		'$scope',
		'NoticeService',
		"$controller"
	];
	function NoticeCtrl(
		$rootScope,
		 $scope,
		 NoticeService,
		 $controller){

		var ctrl = this;
		//Get the default functionality
		var base = $controller('BaseCtrl', {$scope: $scope});

		angular.extend(this, base)

		ctrl.pageSize = 5;

		//methods
		ctrl.loadParentNotices = function(parentId, parentType){
			ctrl.parentId = parentId;
			ctrl.parentType = parentType;
			NoticeService.getAllNoticesByParent(ctrl.parentId,ctrl.parentType)
			.then(function(res){
				ctrl.notices = res;
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM getAllNoticesByParent: ", err);
			});
		};

		// get all Notices
		ctrl.getNotices = function(){
			NoticeService.getAllNotices(ctrl.searchDB)
			.then(function(res){
				ctrl.notices = res.data;
				ctrl.sortBy(ctrl.orderField.field);
				ctrl.noticeCount = res.count;
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM getNotices: ", err);
			});
		}

		// get all Notices for a specific parent
		ctrl.getNoticesModule = function(parentId,parentType){
			ctrl.parentId = parentId;
			ctrl.parentType = parentType;
			NoticeService.getAllNoticesByParent(parentId,parentType)
			.then(function(res){
				ctrl.notices = res;
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM getNotices: ", err);
			});
		}

		// get a specific Notice
		ctrl.getNotice = function(noticeId){
			NoticeService.getNotice(noticeId)
			.then(function(res){
				ctrl.notice = res;
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM getNotices: ", err);
			});
		}

		// delete a specific Notice
		ctrl.deleteNotice= function (noticeId, idx){
			if(confirm('Are you sure you want to delete this notice?')){
				NoticeService.deleteNotice(noticeId)
				.then(function(res){
					ctrl.notices.splice(idx, 1);
					ctrl.fireEvents(res);
				})
				.catch(function(err){
					console.error("ERROR RESPONDING FROM GET ALL USERS: ", err);
				});
			}
		}

		// Search all Notices
		ctrl.searchNotices = function(){
			NoticeService.getAllNotices(ctrl.searchDB)
			.then(function(res){
				ctrl.notices = res.data;
				ctrl.noticeCount = res.count;
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM searchNotices: ", err);
			});
		}

		// Events Listeners
		var createListener = $rootScope.$on('NoticeCtrl.create', function (event, data) {
			ctrl.notices.push(data.payload);
		});
		var updateListener = $rootScope.$on('NoticeCtrl.update', function (event, data) {
			var position = ctrl.notices.map(function(notice){
				return notice.id;
			}).indexOf(data.id);
			ctrl.notices[position] = data;
		});
		var deleteListener = $rootScope.$on('NoticeCtrl.destroy', function (event, data) {
			var position = ctrl.notices.map(function(notice){
				return notice.id;
			}).indexOf(data.object.id);
			ctrl.notices.splice(position,1);
		});

		$scope.$on('$destroy', function(){
			createListener();
			updateListener();
		});
	}
})();
(function(){
	'use strict';
	angular
	.module('myApp')
	.controller('OrderCtrl', OrderCtrl)
	OrderCtrl.$inject = [
		"$rootScope",
		"$scope",
		"OrderService",
		"$controller"
	];
	function OrderCtrl(
		$rootScope,
		$scope,
		OrderService,
		$controller
		){
		var ctrl = this;

		//Get the default functionality
		var base = $controller('BaseCtrl', {$scope: $scope});

		angular.extend(this, base)

		ctrl.columns 			= [
			{'class':'col-md-5','field':'inspection.name','title':'Name'},
			{'class':'col-md-2','field':'paid_in_full','title':'Paid in full'},
			{'class':'col-md-2','field':'amount','title':'Amount'},
			{'class':'col-md-2','field':'amount_paid','title':'Amount paid'},
		];
		ctrl.modColumns 			= [
			{'class':'col-md-2','field':'name','title':'Name'},
			{'class':'col-md-2','field':'description','title':'Description'},
			{'class':'col-md-2','field':'paid_in_full','title':'Paid in full'},
			{'class':'col-md-2','field':'amount','title':'Amount'},
			{'class':'col-md-2','field':'amount_paid','title':'Amount paid'},
		];
		ctrl.orderField 		= ctrl.columns[0];
		ctrl.orders			= [];
		ctrl.order			= {};
		ctrl.order.orderlines= [];
		ctrl.isTabulated= true;
		ctrl.showSearch = false;


		// get all Orders
		ctrl.getOrders = function(){
			OrderService.getAllOrders(ctrl.searchDB)
			.then(function(res){
				ctrl.orders = res.data;
				ctrl.sortBy(ctrl.orderField.field);
				ctrl.orderCount = res.count;
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM getOrders: ", err);
			});
		}

		// get all Orders for a specific parent
		ctrl.getOrdersModule = function(parentId,parentType){
			ctrl.parentId = parentId;
			ctrl.parentType = parentType;
			OrderService.getAllOrdersByParent(parentId,parentType)
			.then(function(res){
				ctrl.orders = res;
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM getOrders: ", err);
			});
		}

		// get a specific Order
		ctrl.getOrder = function(orderId){
			OrderService.getOrder(orderId)
			.then(function(res){
				ctrl.order = res;
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM getOrders: ", err);
			});
		}

		// delete a specific Order
		ctrl.deleteOrder= function (order){
			if(confirm('Are you sure you want to delete this order?')){
				OrderService.deleteOrder(order.uid)
				.then(function(res){
					var position = ctrl.orders.map(function(order){
						return order.id;
					}).indexOf(order.id);
					ctrl.orders.splice(position, 1);
					ctrl.fireEvents(res);
				})
				.catch(function(err){
					console.error("ERROR RESPONDING FROM GET ALL USERS: ", err);
				});
			}
		}

		// Search all Orders
		ctrl.searchOrders = function(){
			OrderService.getAllOrders(ctrl.searchDB)
			.then(function(res){
				ctrl.orders = res.data;
				ctrl.orderCount = res.count;
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM searchOrders: ", err);
			});
		}

		// Events Listeners
		var createListener = $rootScope.$on('OrderCtrl.create', function (event, data) {
			ctrl.orders.push(data.payload);
		});
		var updateListener = $rootScope.$on('OrderCtrl.update', function (event, data) {
			var position = ctrl.orders.map(function(order){
				return order.id;
			}).indexOf(data.id);
			ctrl.orders[position] = data;
		});
		var deleteListener = $rootScope.$on('OrderCtrl.destroy', function (event, data) {
			var position = ctrl.orders.map(function(order){
				return order.id;
			}).indexOf(data.object.id);
			ctrl.orders.splice(position,1);
		});

		$scope.$watch('order', function() {
			ctrl.cartTotal();
		});

		$scope.$on('$destroy', function(){
			createListener();
			updateListener();
		});
	}
})();
(function(){
	'use strict';
	angular
	.module('myApp')
	.controller('OrderlineCtrl', OrderlineCtrl)
	OrderlineCtrl.$inject = [
		"$rootScope",
		"$scope",
		"OrderlineService",
		"$controller"
	];
	function OrderlineCtrl(
		$rootScope,
		$scope,
		OrderlineService,
		$controller){
		var ctrl = this;

		//Get the default functionality
		var base = $controller('BaseCtrl', {$scope: $scope});

		angular.extend(this, base)

		ctrl.columns 			= [
			{'class':'col-md-2','field':'taxable','title':'Taxable'},
			{'class':'col-md-2','field':'product_name','title':'Product name'},
			{'class':'col-md-2','field':'product_description','title':'Product description'},
			{'class':'col-md-2','field':'price_per','title':'Price per'},
			{'class':'col-md-2','field':'line_total','title':'Line total'},
			{'class':'col-md-2','field':'unitofmeasure','title':'Unitofmeasure'},
			{'class':'col-md-2','field':'description','title':'Description'},
			{'class':'col-md-2','field':'qty','title':'Qty'},
		];
		ctrl.modColumns 			= [
			{'class':'col-md-2','field':'taxable','title':'Taxable'},
			{'class':'col-md-2','field':'product_name','title':'Product name'},
			{'class':'col-md-2','field':'product_description','title':'Product description'},
			{'class':'col-md-2','field':'price_per','title':'Price per'},
			{'class':'col-md-2','field':'line_total','title':'Line total'},
			{'class':'col-md-2','field':'unitofmeasure','title':'Unitofmeasure'},
			{'class':'col-md-2','field':'description','title':'Description'},
			{'class':'col-md-2','field':'qty','title':'Qty'},
		];
		ctrl.orderField 		= ctrl.columns[0];
		ctrl.orderlines			= [];
		ctrl.orderline			= {};
		ctrl.isTabulated= true;
		ctrl.showSearch = false;


		// get all Orderlines
		ctrl.getOrderlines = function(){
			OrderlineService.getAllOrderlines(ctrl.searchDB)
			.then(function(res){
				ctrl.orderlines = res.data;
				ctrl.sortBy(ctrl.orderField.field);
				ctrl.orderlineCount = res.count;
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM getOrderlines: ", err);
			});
		}

		// get all Orderlines for a specific parent
		ctrl.getOrderlinesModule = function(parentId,parentType){
			ctrl.parentId = parentId;
			ctrl.parentType = parentType;
			OrderlineService.getAllOrderlinesByParent(parentId,parentType)
			.then(function(res){
				ctrl.orderlines = res;
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM getOrderlines: ", err);
			});
		}

		// get a specific Orderline
		ctrl.getOrderline = function(orderlineId){
			OrderlineService.getOrderline(orderlineId)
			.then(function(res){
				ctrl.orderline = res;
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM getOrderlines: ", err);
			});
		}

		// delete a specific Orderline
		ctrl.deleteOrderline= function (orderline){
			if(confirm('Are you sure you want to delete this orderline?')){
				OrderlineService.deleteOrderline(orderline.uid)
				.then(function(res){
					var position = ctrl.orderlines.map(function(orderline){
						return orderline.id;
					}).indexOf(orderline.id);
					ctrl.orderlines.splice(position, 1);
					ctrl.fireEvents(res);
				})
				.catch(function(err){
					console.error("ERROR RESPONDING FROM GET ALL USERS: ", err);
				});
			}
		}

		// Search all Orderlines
		ctrl.searchOrderlines = function(){
			OrderlineService.getAllOrderlines(ctrl.searchDB)
			.then(function(res){
				ctrl.orderlines = res.data;
				ctrl.orderlineCount = res.count;
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM searchOrderlines: ", err);
			});
		}

		// Events Listeners
		var createListener = $rootScope.$on('OrderlineCtrl.create', function (event, data) {
			ctrl.orderlines.push(data.payload);
		});
		var updateListener = $rootScope.$on('OrderlineCtrl.update', function (event, data) {
			var position = ctrl.orderlines.map(function(orderline){
				return orderline.id;
			}).indexOf(data.id);
			ctrl.orderlines[position] = data;
		});
		var deleteListener = $rootScope.$on('OrderlineCtrl.destroy', function (event, data) {
			var position = ctrl.orderlines.map(function(orderline){
				return orderline.id;
			}).indexOf(data.object.id);
			ctrl.orderlines.splice(position,1);
		});

		$scope.$on('$destroy', function(){
			createListener();
			updateListener();
		});
	}
})();
(function(){
	'use strict';
	angular
	.module('myApp')
	.controller('PersonCtrl', PersonCtrl)
	PersonCtrl.$inject = [
		"$rootScope",
		"$scope",
		"PersonService",
		"PhoneService",
		"AddressService",
		"$controller"
	];
	function PersonCtrl(
		$rootScope,
		$scope,
		PersonService,
		PhoneService,
		AddressService,
		$controller
	){

		var ctrl = this;
		//Get the default functionality
		var base = $controller('BaseCtrl', {$scope: $scope});

		angular.extend(this, base)

		ctrl.columns 		= [
			{'class':'col-md-1','field':'title','title':''},
			{'class':'col-md-1','field':'title','title':'Title'},
			{'class':'col-md-1','field':'first','title':'First'},
			{'class':'col-md-1','field':'last','title':'Last'},
			{'class':'col-md-2','field':'spouse','title':'Spouse'},
			{'class':'col-md-3','field':'email','title':'Email'},
			{'class':'col-md-2','field':'company','title':'Company'},
		];

		ctrl.modColumns 		= [
			{'class':'col-md-2','field':'fullname','title':'Name'},
			{'class':'col-md-2','field':'title','title':'Title'},
			{'class':'col-md-2','field':'email','title':'Email'},
			{'class':'col-md-3','field':'phone.phone','title':'Phone'}
		];

		ctrl.orderField = ctrl.columns[0];
		ctrl.councils	= [];
		ctrl.council	= {};
		ctrl.pageSize	= 25;
		ctrl.isTabulated= true;
		ctrl.showSearch = false;

		ctrl.getParentPeople = function(parentId,parentType){
			ctrl.parentId = parentId;
			ctrl.parentType = parentType;
			PersonService.getAllPeopleByParent(parentId,parentType)
			.then(function(res){
				ctrl.people = res;
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM getPeople: ", err);
			});
		}

		ctrl.getPeople = function(){
			PersonService.getAllPeople()
			.then(function(res){
				ctrl.people = res;
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM getPeople: ", err);
			});
		}

		ctrl.getPeopleByTag = function(tag){
			PersonService.getPeopleByScope('ByTag', 'false', tag)
			.then(function(res){
				ctrl.people = res;
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM getPeopleByTag: ", err);
			});
		}

		ctrl.searchPeople = function(){
			PersonService.searchPeople()
			.then(function(res){
				ctrl.people = res;
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM searchPeople: ", err);
			});
		}

		ctrl.getPerson = function(personId){
			PersonService.getPerson(personId)
			.then(function(res){
				ctrl.person = res;
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM getPeople: ", err);
			});
		}

		ctrl.deletePerson = function (person){
			if(confirm('Are you sure you want to delete this person?')){
				PersonService.deletePerson(person.uid)
				.then(function(res){
					var position = ctrl.people.map(function(person){
						return person.id;
					}).indexOf(res.id);
					ctrl.people.splice(position, 1);
					ctrl.fireEvents(res);
				})
				.catch(function(err){
					console.error("ERROR RESPONDING FROM GET ALL USERS: ", err);
				});
			}
		}

		ctrl.deletePhone = function (phone){
			if(confirm('Are you sure you want to delete this phone?')){
				PhoneService.deletePhone(phone.uid)
				.then(function(res){
					ctrl.getParentPeople(ctrl.parentId,ctrl.parentType);
				})
				.catch(function(err){
					console.error("ERROR RESPONDING FROM GET ALL USERS: ", err);
				});
			}
		}

		ctrl.deleteAddress = function (address){
			if(confirm('Are you sure you want to delete this address?')){
				AddressService.deleteAddress(address.uid)
				.then(function(res){
					ctrl.getParentPeople(ctrl.parentId,ctrl.parentType);
				})
				.catch(function(err){
					console.error("ERROR RESPONDING FROM GET ALL USERS: ", err);
				});
			}
		}

		// Events Listener
		var createListener = $rootScope.$on('PersonCtrl.create', function (event, data) {
			ctrl.people.push(data.payload);
		});
		var updateListener = $rootScope.$on('PersonCtrl.update', function (event, data) {
			// do nothing
		});
		var deleteListener = $rootScope.$on('PersonCtrl.destroy', function (event, data) {
			var position = ctrl.people.map(function(person){
				return person.id;
			}).indexOf(data.object.id);
			ctrl.people.splice(position,1);
		});

		var createAddressListener = $rootScope.$on('AddressCtrl.create', function (event, data) {
			ctrl.getParentPeople(ctrl.parentId,ctrl.parentType);
		});
		var refreshListener = $rootScope.$on('PersonCtrl.refresh', function (event, data) {
			ctrl.getParentPeople(ctrl.parentId,ctrl.parentType);
		});

		$scope.$on('$destroy', function(){
			createListener();
			updateListener();
		});
	}
})();

(function(){
	'use strict';
	angular
	.module('myApp')
	.controller('PhoneCtrl', PhoneCtrl)
	PhoneCtrl.$inject = [
		"$rootScope",
		"$scope",
		"PhoneService",
		"$controller"
	];
	function PhoneCtrl(
		$rootScope,
		$scope,
		PhoneService,
		$controller
	){

		var ctrl = this;
		//Get the default functionality
		var base = $controller('BaseCtrl', {$scope: $scope});

		angular.extend(this, base)

		 //methods
		ctrl.loadPhones = function(parentId, parentType){
			ctrl.parentId = parentId;
			ctrl.parentType = parentType;
			PhoneService.getAllPhonesByParent(parentId,parentType)
			.then(function(res){
				ctrl.phones = res;
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error('Error occurred: ',err);
			});
		};

		ctrl.deletePhone = function (phone){
			if(confirm('Are you certain you want to delete this phone?')) {
				PhoneService.deletePhone(phone.uid)
				.then(function(res){
					var position = ctrl.phones.map(function(phone){
						return phone.id;
					}).indexOf(res.id);
					ctrl.phones.splice(position,1);
				})
				.catch(function(err){
					console.error("ERROR RESPONDING FROM deletePhone: ", err);
				});
			}
		};

		// Events Listener
		var createListener = $rootScope.$on('PhoneCtrl.create', function (event, data) {
			ctrl.phones.push(data.payload);
		});

		var updateListener = $rootScope.$on('PhoneCtrl.update', function (event, data) {
			ctrl.loadPhones(ctrl.parentId,ctrl.parentType);
		});

		var reloadListener = $rootScope.$on('PhoneCtrl.reload', function (event, data) {
			ctrl.loadPhones(ctrl.parentId,ctrl.parentType);
		});

		var deleteListener = $rootScope.$on('PhoneCtrl.delete', function (event, data) {});

		//Events Listener
		$scope.$on('$destroy', function(){
			createListener();
			updateListener();
			reloadListener();
		});
	}
})();
(function(){
	'use strict';
	angular
	.module('myApp')
	.controller('ProductCtrl', ProductCtrl)
	ProductCtrl.$inject = [
		"$rootScope",
		"$scope",
		"ProductService",
		"$controller"];
	function ProductCtrl(
		$rootScope,
		$scope,
		ProductService,
		$controller){
		var ctrl = this;

		//Get the default functionality
		var base = $controller('BaseCtrl', {$scope: $scope});

		angular.extend(this, base)

		ctrl.columns 			= [
			{'class':'col-md-2','field':'name','title':'Name'},
			{'class':'col-md-8','field':'blurb','title':'Blurb'},
			{'class':'col-md-1','field':'price','title':'Price'},
		];
		ctrl.modColumns 			= [
			{'class':'col-md-2','field':'name','title':'Name'},
			{'class':'col-md-2','field':'image','title':'Image'},
			{'class':'col-md-2','field':'blurb','title':'Blurb'},
			{'class':'col-md-2','field':'description','title':'Description'},
			{'class':'col-md-2','field':'price','title':'Price'},
		];
		ctrl.orderField 		= ctrl.columns[0];
		ctrl.products			= [];
		ctrl.product			= {};
		ctrl.isTabulated= true;
		ctrl.showSearch = false;


		// get all Products
		ctrl.getProducts = function(){
			ProductService.getAllProducts(ctrl.searchDB)
			.then(function(res){
				ctrl.products = res.data;
				ctrl.sortBy(ctrl.orderField.field);
				ctrl.productCount = res.count;
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM getProducts: ", err);
			});
		}

		// get all Products for a specific parent
		ctrl.getProductsModule = function(parentId,parentType){
			ctrl.parentId = parentId;
			ctrl.parentType = parentType;
			ProductService.getAllProductsByParent(parentId,parentType)
			.then(function(res){
				ctrl.products = res;
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM getProducts: ", err);
			});
		}

		// get a specific Product
		ctrl.getProduct = function(productId){
			ProductService.getProduct(productId)
			.then(function(res){
				ctrl.product = res;
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM getProducts: ", err);
			});
		}

		// delete a specific Product
		ctrl.deleteProduct= function (product){
			if(confirm('Are you sure you want to delete this product?')){
				ProductService.deleteProduct(product.uid)
				.then(function(res){
					var position = ctrl.products.map(function(product){
						return product.id;
					}).indexOf(product.id);
					ctrl.products.splice(position, 1);
					ctrl.fireEvents(res);
				})
				.catch(function(err){
					console.error("ERROR RESPONDING FROM GET ALL USERS: ", err);
				});
			}
		}

		// Search all Products
		ctrl.searchProducts = function(){
			ProductService.getAllProducts(ctrl.searchDB)
			.then(function(res){
				ctrl.products = res.data;
				ctrl.productCount = res.count;
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM searchProducts: ", err);
			});
		}

		// Events Listeners
		var createListener = $rootScope.$on('ProductCtrl.create', function (event, data) {
			ctrl.products.push(data.payload);
		});
		var updateListener = $rootScope.$on('ProductCtrl.update', function (event, data) {
			var position = ctrl.products.map(function(product){
				return product.id;
			}).indexOf(data.id);
			ctrl.products[position] = data;
		});
		var deleteListener = $rootScope.$on('ProductCtrl.destroy', function (event, data) {
			var position = ctrl.products.map(function(product){
				return product.id;
			}).indexOf(data.object.id);
			ctrl.products.splice(position,1);
		});

		$scope.$on('$destroy', function(){
			createListener();
			updateListener();
		});
	}
})();
(function(){
	'use strict';
	angular
	.module('myApp')
	.controller('ProductFormController', ProductFormController)
	ProductFormController.$inject = [
		'$rootScope',
		'$scope',
		'$uibModalInstance',
		'items',
		'ProductService',
		'textAngularManager'
	];
		function ProductFormController(
		$rootScope,
		$scope,
		$uibModalInstance,
		items,
		ProductService,
		textAngularManager){
			$scope.hasError = false;
			$scope.errors = [];
			$scope.payload = items.payload;
			if(items.bind != undefined)
			{
				$scope.bind = items.bind;
			}
			var expectEvent = items.expect;

			var originalObj = angular.extend({}, items.bind);

			$scope.toolbarButtons = [
				['h1', 'h2', 'h3', 'h4', 'p', 'quote'],
				['bold', 'italics', 'underline', 'strikeThrough', 'ul', 'ol', 'redo', 'undo', 'clear'],
				['justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull', 'indent', 'outdent'],
				['html', 'insertImage','insertLink']
			];

			$scope.changeType = function(value){
				var parts = value.split("\\");
				$scope.modelName = parts[parts.length - 1];
			};

			$scope.insertHtml = function(qtvar) {
				var template = '[%var%]';
				template =  template.replace(/%var%/g, qtvar);
				this.$editor().wrapSelection('inserthtml', template);
			};

			$scope.insertPlaceholder = function(text) {
				insertHtml.call(this, text);
			};

			$scope.getPlaceholders = function(){
				if(!$scope.bind.type){
					return;
				}
				var parts = $scope.bind.type.split("\\");
				$scope.modelName = parts[parts.length - 1];
				ProductService.getProductPlaceholders($scope.modelName)
				.then(function(res){
					var contentItems = [];
					angular.forEach(res, function(value, key) {
						contentItems.push({'text':value,click:'action(item)'});
					});

					textAngularManager.removeTool('insertPlaceholder');
					textAngularManager.addTool('insertPlaceholder', {
						display: '<button class="btn" type="button" data-animation="am-fade" bs-dropdown="content" aria-haspopup="true" aria-expanded="false">Select parameter</button>',
						content:contentItems,
						action: function (item) {
							if (item.text) {
								this.$editor().wrapSelection('insertHtml', '[' + item.text + ']');
							}
						},
						options: res
					},2);

				})
				.catch(function(err){
					console.error("ERROR RESPONDING FROM getProducts: ", err);
				});
			}

			$scope.addProduct = function(){
				var data = $scope.bind
				ProductService.addProduct(data)
				.then(function(res){
					$scope.fireEvents(res);
					$uibModalInstance.close(res);
				})
				.catch(function(err){
					console.error("ERROR RESPONDING FROM addProduct: ", err);
				});
			}

			$scope.updateProduct = function(toquetmpl){
				var data = $scope.bind
				ProductService.updateProduct($scope.bind.id, data)
				.then(function(res){
					$scope.fireEvents(res);
					$uibModalInstance.close(res);
				})
				.catch(function(err){
					console.error("ERROR RESPONDING FROM updateProduct: ", err);
				});
			}

			$scope.updateCampaignTouchTemplate = function(){
				var data = $scope.bind
				ProductService.updateCampaignTouchTemplate(data.parentId,data.parentType,$scope.bind.id, data)
				.then(function(res){
					$scope.fireEvents(res);
					$uibModalInstance.close(res);
				})
				.catch(function(err){
					console.error("ERROR RESPONDING FROM updateCampaignTouchTemplate: ", err);
				});
			}

			$scope.deleteProduct = function (toquetmplId, idx){
				if(confirm('Are you sure you want to delete this toquetmpl?')){
					ProductService.deleteProduct(toquetmplId)
					.then(function(res){
						$scope.toquetmpls.splice(idx, 1);
						$scope.fireEvents(res);
					})
					.catch(function(err){
						console.error("ERROR RESPONDING FROM GET ALL USERS: ", err);
					});
				}
			}

			$scope.fireEvents = function(d){
				if(expectEvent != undefined && expectEvent != ''){
					$rootScope.$emit(expectEvent, d);
				}else{
				}
			}

			$scope.cancel = function () {
				if($scope.bind != undefined){}
				$uibModalInstance.dismiss('cancel');
			}

			$scope.$watch('bind.type',function(o,n){
				$scope.placeholders = [];
				$scope.getPlaceholders();
			});

	}
})();
(function(){
	'use strict';
	angular
	.module('myApp')
	.controller('RegisterCtrl', RegisterCtrl)
	RegisterCtrl.$inject = [
		"$rootScope",
		"$scope",
		"$window",
		"RegisterService",
		"$controller"
	];
	function RegisterCtrl(
		$rootScope,
		$scope,
		$window,
		RegisterService,
		$controller
		){
		var ctrl = this;

		//Get the default functionality
		var base = $controller('BaseCtrl', {$scope: $scope});

		angular.extend(this, base)

		ctrl.password = '';
		ctrl.password_confirmation = '';
		ctrl.userId = 0;
		// set the userId
		ctrl.setId = function(userId){
			ctrl.userId = userId;
		}

		// updatet the user's password, etc.
		ctrl.updateUser = function(){
			var data = {
				password:ctrl.password,
				password_confirmation:ctrl.password_confirmation,
			}
			if (ctrl.first != undefined) {
				data.first = ctrl.first
			}
			if (ctrl.last != undefined) {
				data.last = ctrl.last
			}
			RegisterService.updateUserRegister(ctrl.userId, data)
			.then(function(res){
				// probably a redirect or show errors
				$window.location.href = res.redirect;
			})
			.catch(function(err){
				if (err.status == 422) {
					ctrl.errors = ctrl.processErrors(err.data.errors);
					ctrl.hasError = true;
				}
				console.error("ERROR RESPONDING FROM getBanks: ", err);
			});
		}

		$scope.submit = ctrl.updateUser;

		// Events Listeners
		var createListener = $rootScope.$on('RegisterCtrl.create', function (event, data) {});
		var updateListener = $rootScope.$on('RegisterCtrl.update', function (event, data) {});
		var deleteListener = $rootScope.$on('RegisterCtrl.destroy', function (event, data) {});

		$scope.$on('$destroy', function(){
			createListener();
			updateListener();
		});
	}
})();
(function(){
	'use strict';
	angular
	.module('myApp')
	.controller('RoleCtrl', RoleCtrl)
	RoleCtrl.$inject = ["$rootScope","$scope","$http","$filter","$uibModal","RoleService","$controller"];
	function RoleCtrl($rootScope,$scope, $http, $filter, $uibModal, RoleService, $controller){

		var ctrl = this;

		//Get the default functionality
		var base = $controller('BaseCtrl', {$scope: $scope});

		angular.extend(this, base)

		ctrl.columns 			= [
			{'class':'col-md-2','field':'name','title':'Name'},
			{'class':'col-md-9','field':'description','title':'Description'}
		];
		ctrl.orderField 	= ctrl.columns[0];
		ctrl.roles			= [];
		ctrl.accessRoles	= [];
		ctrl.role			= {};

		// get all Roles
		ctrl.getRoles = function(){
			RoleService.getAllRoles(ctrl.searchDB)
			.then(function(res){
				ctrl.roles = res;
				angular.forEach(ctrl.roles, function(value, key) {
					value.grants = (ctrl.accessRoles[value.id] !== undefined)
				});
				ctrl.isLoaded = true;
				ctrl.sortBy('id');

			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM getRoles: ", err);
			});
		}

		// get all Roles
		ctrl.getCurrentRoles = function(){
			RoleService.getAllRoles(ctrl.searchDB)
			.then(function(res){
				ctrl.roles = res;
				angular.forEach(ctrl.roles, function(role, key) {
					var position = ctrl.permissions.map(function (permission) {
						return permission.id;
					}).indexOf(role.id);
					role.grants = (position !== -1)
				});
				ctrl.isLoaded = true;
				ctrl.sortBy('id');

			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM getRoles: ", err);
			});
		}

		// get all Roles for a specific parent
		ctrl.getRolesModule = function(parentId,parentType){
			ctrl.parentId = parentId;
			ctrl.parentType = parentType;
			RoleService.getGrantRolesByParent(parentId,parentType)
			.then(function(res){
				ctrl.accessRoles = res;
				ctrl.getRoles();
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM getRoles: ", err);
			});
		}

		// get all Roles for a specific parent
		ctrl.getRolesParent = function(parentId,parentType){
			ctrl.parentId = parentId;
			ctrl.parentType = parentType;
			RoleService.getAllRolesByParent(parentId,parentType)
			.then(function(res){
				ctrl.permissions = res;
				ctrl.getCurrentRoles();
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM getRoles: ", err);
			});
		}

		// get a specific Role
		ctrl.getRole = function(RoleId){
			RoleService.getRole(RoleId)
			.then(function(res){
				ctrl.role = res;
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM getRoles: ", err);
			});
		}

		// delete a specific Role
		ctrl.deleteRole= function (role, idx){
			if(confirm('Are you sure you want to delete this Role?')){
				RoleService.deleteRole(role.id)
				.then(function(res){
					ctrl.roles.splice(idx, 1);
					ctrl.fireEvents(res);
				})
				.catch(function(err){
					console.error("ERROR RESPONDING FROM GET ALL USERS: ", err);
				});
			}
		}

		// Search all Roles
		ctrl.searchRoles = function(qry){
			RoleService.searchRoles(qry)
			.then(function(res){
				ctrl.roles = res;
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM searchRoles: ", err);
			});
		}

		// Toggle Role permission
		ctrl.toggleGrant = function(role){
			var data = {
				parentId:ctrl.parentId,
				parentType:ctrl.parentType,
				roleId:role.id,
			}
			if(role.grants){
				RoleService.detachRole(data)
				.then(function(res){

				})
				.catch(function(err){
					console.error("ERROR RESPONDING FROM searchRoles: ", err);
				});
			} else {
				RoleService.attachRole(data)
				.then(function(res){

				})
				.catch(function(err){
					console.error("ERROR RESPONDING FROM searchRoles: ", err);
				});

			}
		}

		// Events Listeners
		var createListener = $rootScope.$on('RoleCtrl.create', function (event, data) {
			ctrl.roles.push(data.payload);
		});
		var updateListener = $rootScope.$on('RoleCtrl.update', function (event, data) {
			var position = ctrl.roles.map(function(Role){
				return Role.id;
			}).indexOf(data.id);
			ctrl.roles[position] = data;
		});
		var deleteListener = $rootScope.$on('RoleCtrl.destroy', function (event, data) {
			var position = ctrl.roles.map(function(Role){
				return Role.id;
			}).indexOf(data.object.id);
			ctrl.roles.splice(position,1);
		});

		$scope.$on('$destroy', function(){
			createListener();
			updateListener();
		});
	}
})();
(function(){
	'use strict';
	angular
	.module('myApp')
	.controller('SettingCtrl', SettingCtrl)
	SettingCtrl.$inject = ["$rootScope","$scope","$http","$filter","$uibModal","SettingService","$controller"];
	function SettingCtrl($rootScope,$scope, $http, $filter, $uibModal, SettingService, $controller){

		var ctrl = this;
		//Get the default functionality
		var base = $controller('BaseCtrl', {$scope: $scope});

		angular.extend(this, base)

		ctrl.settings = [];
		ctrl.columns = [
			{ 'class': 'col-md-6', 'field': 'message', 'title': 'Message' },
			{ 'class': 'col-md-6', 'field': 'severity', 'title': 'Severity' }
		];
		ctrl.modColumns 	= [
			{'class':'col-md-6','field':'message','title':'Message'},
			{'class':'col-md-6','field':'severity','title':'Severity'}
		];

		//methods
		ctrl.loadParentSettings = function(parentId,parentType){
			ctrl.parentId = parentId;
			ctrl.parentType = parentType;
			SettingService.getAllSettingsByParent(ctrl.parentId,ctrl.parentType)
			.then(function(res){
				ctrl.settings = res;
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM getSettings: ", err);
			});
		}

		ctrl.getSettings = function(){
			SettingService.getAllSettings()
			.then(function(res){
				ctrl.settings = res.data;
				SettingService.getAllSettingOpts()
				.then(function(res){
					ctrl.settingOpts = res;
					ctrl.isLoaded = true;
				})
				.catch(function(err){
					console.error("ERROR RESPONDING FROM getSettings: ", err);
				});
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM getSettings: ", err);
			});
		}



		ctrl.deleteSetting = function (setting){
			if(confirm('Are you sure you want to delete this setting?')){
				SettingService.deleteSetting(setting.uid)
				.then(function(res){
					var position = ctrl.settings.map(function (setting) {
						return setting.id;
					}).indexOf(setting.id);
					ctrl.settings.splice(position, 1);
				})
				.catch(function(err){
					console.error("ERROR RESPONDING FROM GET ALL USERS: ", err);
				});
			}
		}


		// Events Listener
		var createListener = $rootScope.$on('SettingCtrl.create', function (event, data) {
			ctrl.settings.push(data.payload);
		});
		var updateListener = $rootScope.$on('SettingCtrl.update', function (event, data) {});
		var deleteListener = $rootScope.$on('SettingCtrl.destroy', function (event, data) {
			var position = ctrl.settings.map(function(settings){
				return settings.id;
			}).indexOf(data.payload.id);
			ctrl.settings.splice(position,1);
		});

		$scope.$on('$destroy', function(){
			createListener();
			updateListener();
		});
	}
})();

(function(){
	'use strict';
	angular
	.module('myApp')
	.controller('StateCtrl', StateCtrl)
	StateCtrl.$inject = ["$rootScope","$scope","$http","$filter","$uibModal","StateService","$controller"];
	function StateCtrl($rootScope,$scope, $http, $filter, $uibModal, StateService, $controller){

		var ctrl = this;
		//Get the default functionality
		var base = $controller('BaseCtrl', {$scope: $scope});

		angular.extend(this, base)

		ctrl.columns 		= [
			{'class':'col-md-4','field':'abbr','title':'Abbr'},
			{'class':'col-md-7','field':'fullname','title':'Name'},
		];
		ctrl.isReverse=false;
		ctrl.field="fullname";

		ctrl.loadParentStates = function(parentId,parentType){
			ctrl.parentId = parentId;
			ctrl.parentType = parentType;
			StateService.getAllStatesByParent(ctrl.parentId,ctrl.parentType)
			.then(function(res){
				ctrl.us_states = res;
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM getStates: ", err);
			});
		}

		ctrl.loadParentMissingStates = function(parentId,parentType){
			ctrl.parentId = parentId;
			ctrl.parentType = parentType;
			StateService.getMissingStatesByParent(ctrl.parentId,ctrl.parentType)
			.then(function(res){
				ctrl.missing_states = res;
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM getStates: ", err);
			});
		}

		ctrl.getStates = function(){
			StateService.getAllStates()
			.then(function(res){
				ctrl.all_states = res;
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM getStates: ", err);
			});
		}

		ctrl.getStates = function(){
			StateService.getAllStates()
			.then(function(res){
				ctrl.us_states = res;
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM getStates: ", err);
			});
		}

		ctrl.attachState = function(stateId, idx){
			var data = {
				parentId:ctrl.parentId,
				parentType:ctrl.parentType,
				stateId:stateId,
			}
			StateService.attachState(data)
			.then(function(res){
				ctrl.us_states.push(res);
				ctrl.missing_states.splice(idx, 1);
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM attachState: ", err);
			});
		}

		ctrl.detachState = function(state, idx){
			var data = {
				parentId:ctrl.parentId,
				parentType:ctrl.parentType,
				stateId:state.id,
			}
			StateService.detachState(data)
			.then(function(res){
				ctrl.missing_states.push(state);
				ctrl.us_states.splice(idx, 1);
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM detachState: ", err);
			});
		}

		ctrl.deleteState= function (stateId, idx){
			if(confirm('Are you sure you want to delete this state?')){
				StateService.deleteState(stateId)
				.then(function(res){
					ctrl.us_states.splice(idx, 1);
					ctrl.fireEvents(res);
				})
				.catch(function(err){
					console.error("ERROR RESPONDING FROM GET ALL USERS: ", err);
				});
			}
		}

		// Events Listener
		var createListener = $rootScope.$on('StateCtrl.create', function (event, data) {
			ctrl.us_states.push(data.payload);
		});
		var updateListener = $rootScope.$on('StateCtrl.update', function (event, data) {
			// do nothing
		});
		var deleteListener = $rootScope.$on('StateCtrl.destroy', function (event, data) {
			var position = ctrl.us_states.map(function(state){
				return state.id;
			}).indexOf(data.object.id);
			ctrl.us_states.splice(position,1);
		});

		$scope.$on('$destroy', function(){
			createListener();
			updateListener();
		});
	}
})();

(function(){
	'use strict';
	angular
	.module('myApp')
	.controller('StatusfierCtrl', StatusfierCtrl)
	StatusfierCtrl.$inject = [
		"$rootScope",
		"$scope",
		"StatusfierService",
		"$controller"
	];
	function StatusfierCtrl(
		$rootScope,
		$scope,
		StatusfierService,
		$controller){
		var ctrl = this;

		//Get the default functionality
		var base = $controller('BaseCtrl', {$scope: $scope});

		//this

		angular.extend(this, base)

		ctrl.columns 			= [
			{'class':'col-md-1','field':'category','title':'Category'},
			{'class':'col-md-1','field':'status','title':'Status'},
			{'class':'col-md-1','field':'model','title':'Model'},
			{'class':'col-md-8','field':'description','title':'Description'},
		];
		ctrl.orderField 	= 'status';
		ctrl.statusfiers	= [];
		ctrl.statusfier		= {};
		ctrl.isTabulated	= true;


		// get all Statusfiers
		ctrl.getStatusfiers = function(){
			StatusfierService.getAllStatusfiers(ctrl.searchDB)
			.then(function(res){
				ctrl.statusfiers = res.data;
				ctrl.sortBy(ctrl.orderField.field);
				ctrl.statusfierCount = res.count;
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM getStatusfiers: ", err);
			});
		}

		// get all Statusfiers for a specific parent
		ctrl.getStatusfiersModule = function(parentId,parentType){
			ctrl.parentId = parentId;
			ctrl.parentType = parentType;
			StatusfierService.getAllStatusfiersByParent(parentId,parentType)
			.then(function(res){
				ctrl.statusfiers = res;
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM getStatusfiers: ", err);
			});
		}

		// get a specific Statusfier
		ctrl.getStatusfier = function(statusfierId){
			StatusfierService.getStatusfier(statusfierId)
			.then(function(res){
				ctrl.statusfier = res;
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM getStatusfiers: ", err);
			});
		}

		// delete a specific Statusfier
		ctrl.deleteStatusfier= function (statusfier){
			if(confirm('Are you sure you want to delete this statusfier?')){
				StatusfierService.deleteStatusfier(statusfier.uid)
				.then(function(res){
					var position = ctrl.statusfiers.map(function(statusfier){
						return statusfier.id;
					}).indexOf(res.id);
					ctrl.statusfiers.splice(position,1);
				})
				.catch(function(err){
					console.error("ERROR RESPONDING FROM GET ALL USERS: ", err);
				});
			}
		}

		// Search all Statusfiers
		ctrl.searchStatusfiers = function(){
			StatusfierService.getAllStatusfiers(ctrl.searchDB)
			.then(function(res){
				ctrl.statusfiers = res;
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM searchStatusfiers: ", err);
			});
		}

		// Events Listeners
		var createListener = $rootScope.$on('StatusfierCtrl.create', function (event, data) {
			ctrl.statusfiers.push(data.payload);
		});
		var updateListener = $rootScope.$on('StatusfierCtrl.update', function (event, data) {
			var position = ctrl.statusfiers.map(function(statusfier){
				return statusfier.id;
			}).indexOf(data.id);
			ctrl.statusfiers[position] = data;
		});
		var deleteListener = $rootScope.$on('StatusfierCtrl.destroy', function (event, data) {
			var position = ctrl.statusfiers.map(function(statusfier){
				return statusfier.id;
			}).indexOf(data.object.id);
			ctrl.statusfiers.splice(position,1);
		});

		$scope.$on('$destroy', function(){
			createListener();
			updateListener();
		});
	}
})();
(function () {
	'use strict';
	angular
		.module('myApp')
		.controller('TagCtrl', TagCtrl)
	TagCtrl.$inject = [
		'$rootScope',
		'$scope',
		"$controller",
		"TagService"
	];
	function TagCtrl(
		$rootScope,
		$scope,
		$controller,
		TagService
	) {

		var ctrl = this;
		//Get the default functionality
		var base = $controller('BaseCtrl', {$scope: $scope});

		angular.extend(this, base)

		ctrl.settagData = {};
		ctrl.maxQty = 1;
		ctrl.minQty = 10000000000;
		ctrl.tagRange = 0;

		//methods
		ctrl.loadParentTags = function (parentId, parentType) {
			ctrl.parentId = parentId;
			ctrl.parentType = parentType;
			TagService.getAllTagsByParent(ctrl.parentId, ctrl.parentType)
				.then(function (res) {
					ctrl.tags = res;
					ctrl.isLoaded = true;
				})
				.catch(function (err) {
					console.error("ERROR RESPONDING FROM getAllTagsByParent: ", err);
				});
		};

		//methods
		ctrl.getModelTags = function (model) {
			TagService.getAllTagsByModel(model)
				.then(function (res) {
					ctrl.tags = res;
					angular.forEach(ctrl.tags, function (tag, index) {
						if (tag.qty > ctrl.maxQty) {
							ctrl.maxQty = tag.qty;
						}
						if (tag.qty < ctrl.minQty) {
							ctrl.minQty = tag.qty;
						}
					});
					ctrl.tagRange = ctrl.maxQty - ctrl.minQty + 1;
					ctrl.tagDivisor = ((ctrl.tagRange/10) > 1) ? ctrl.tagRange/10 : 1;
					ctrl.isLoaded = true;
				})
				.catch(function (err) {
					console.error("ERROR RESPONDING FROM getAllTagsByModel: ", err);
				});
		};

		ctrl.saveData = function (tag) {
			var data = {
				tag: tag.tag,
				parentType: ctrl.parentType,
				parentId: ctrl.parentId,
			}
			return TagService.addTag(data)
				.then(function (res) {
					ctrl.tags.push(res);
				})
				.catch(function (err) {
					console.error("ERROR RESPONDING FROM addTag: ", err);
				});
		};

		ctrl.deleteTag = function (tag, idx) {
			if (confirm('Are you sure you want to delete this tag?')) {
				TagService.deleteTag(tag.id)
					.then(function (res) {
					})
					.catch(function (err) {
						console.error("ERROR RESPONDING FROM GET ALL USERS: ", err);
					});
			}
		}

		ctrl.removeDupe = function () {
			angular.forEach(ctrl.tags, function (tag, key) {
				if (tag.id == undefined) {
					ctrl.tags.splice(key, 1);
				}
			});
		}

		ctrl.getCloudClass = function (qty) {
			var tierNames = ['','tier1','tier2','tier3','tier4','tier5','tier6','tier7','tier8','tier9','tier10'];
			var key = Math.ceil(qty/ctrl.tagDivisor);
			return tierNames[key];
		}
		// Events Listener
		var createListener = $rootScope.$on('TagCtrl.create', function (event, data) {
			ctrl.tags.push(data.payload);
		});

		var updateListener = $rootScope.$on('TagCtrl.update', function (event, data) {});

		var reloadListener = $rootScope.$on('TagCtrl.reload', function (event, data) {
			ctrl.loadTags(ctrl.parentId, ctrl.parentType);
		});

		//Events Listener
		$scope.$on('$destroy', function () {
			createListener();
			updateListener();
			reloadListener();
		});
	}
})();
(function(){
	'use strict';
	angular
	.module('myApp')
	.controller('TaskCtrl', TaskCtrl)
	TaskCtrl.$inject = [
		"$rootScope",
		"$scope",
		"TaskService",
		"$controller"
	];
	function TaskCtrl(
		$rootScope,
		$scope,
		TaskService,
		$controller){

		var ctrl = this;

		//Get the default functionality
		var base = $controller('BaseCtrl', {$scope: $scope});

		angular.extend(this, base)

		ctrl.columns 		= [
			{'class':'col-md-2','field':'memo','title':'Memo'},
			{'class':'col-md-2','field':'details','title':'Details'},
			{'class':'col-md-2','field':'notes','title':'Notes'},
			{'class':'col-md-2','field':'completed_details','title':'Completed_details'},
			{'class':'col-md-2','field':'created_by','title':'Created_by'},
			{'class':'col-md-2','field':'assigned_to','title':'Assigned_to'},
			{'class':'col-md-2','field':'due_on','title':'Due_on'},
			{'class':'col-md-2','field':'completed_on','title':'Completed_on'}
		];

		ctrl.recentTasks = [];

		//methods
		ctrl.loadParentTasks = function(parentId, parentType){
			TaskService.getAllTasksByParent(parentId, parentType)
			.then(function(res){
				ctrl.tasks = res;
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM getTasks: ", err);
			});
		}

		ctrl.loadMyTasks = function () {
			TaskService.getMyTasks()
				.then(function (res) {
					ctrl.tasks = res;
					ctrl.loadMyRecentTasks();
					ctrl.isLoaded = true;
				})
				.catch(function (err) {
					console.error("ERROR RESPONDING FROM getTasks: ", err);
				});
		}

		ctrl.loadRecentUserTasks = function (userId) {
			TaskService.getRecentTasksByUser(userId)
				.then(function (res) {
					ctrl.recentTasks = res;
					ctrl.isLoaded = true;
				})
				.catch(function (err) {
					console.error("ERROR RESPONDING FROM getTasks: ", err);
				});
		}

		ctrl.loadMyRecentTasks = function () {
			TaskService.getMyRecentTasks()
				.then(function (res) {
					ctrl.recentTasks = res;
					ctrl.isLoaded = true;
				})
				.catch(function (err) {
					console.error("ERROR RESPONDING FROM getTasks: ", err);
				});
		}

		ctrl.getTasks = function(){
			TaskService.getAllTasks()
			.then(function(res){
				ctrl.tasks = res;
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM getTasks: ", err);
			});
		}

		ctrl.getTask = function(taskId){
			TaskService.getTask(taskId)
			.then(function(res){
				ctrl.task = res;
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM getTasks: ", err);
			});
		}

		ctrl.searchTasks = function () {
			TaskService.getAllTasks(ctrl.searchDB)
				.then(function (res) {
					ctrl.tasks = res.data;
					ctrl.sortBy(ctrl.orderField.field);
					ctrl.taskCount = res.count;
					ctrl.isLoaded = true;
				})
				.catch(function (err) {
					console.error("ERROR RESPONDING FROM getTasks: ", err);
				});
		}

		ctrl.getTasksByCategory = function(categoryId){
			TaskService.getTasksByCategory(categoryId)
			.then(function(res){
				ctrl.tasks = res;
				if(ctrl.tasks.length > 0){
					// ctrl.sortBy(ctrl.orderField.field);
					ctrl.category = res[0].category.name
				} else {
					ctrl.category = 'No Results';
				}
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM getTasks: ", err);
			});
		}

		ctrl.deleteTask= function (taskId, idx){
			if(confirm('Are you sure you want to delete this task?')){
				TaskService.deleteTask(taskId)
				.then(function(res){
					ctrl.tasks.splice(idx, 1);
					$rootScope.$emit('ChangeCtrl.reload');
				})
				.catch(function(err){
					console.error("ERROR RESPONDING FROM GET ALL USERS: ", err);
				});
			}
		}

		ctrl.completeTask= function (task, idx){
			task.completed_on = moment().format('YYYY-MM-DD HH:mm:ss');
			task.add_change_record = "complete";
			TaskService.updateTask(task.uid,task)
			.then(function(res){
				delete task.add_change_record;
				var position = ctrl.tasks.map(function(task){
					return task.id;
				}).indexOf(res.id);
				ctrl.tasks.splice(position,1);
				ctrl.recentTasks.push(task);
				$rootScope.$emit('ChangeCtrl.reload');
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM GET ALL USERS: ", err);
			});
		}

		ctrl.resetTask= function (task, idx){
			if(confirm('Are you sure you want to reset this task?')){
				task.completed_on = null;
				task.add_change_record = "reset";
				TaskService.updateTask(task.uid,task)
				.then(function(res){
					delete task.add_change_record;
					var position = ctrl.recentTasks.map(function(task){
						return task.id;
					}).indexOf(res.id);
					ctrl.recentTasks.splice(position,1);
					ctrl.tasks.push(task);
						$rootScope.$emit('ChangeCtrl.reload');
				})
				.catch(function(err){
					console.error("ERROR RESPONDING FROM GET ALL USERS: ", err);
				});
			}
		}

		// Search all Meetings
		ctrl.getInclude = function (task) {
			switch (task.show_link.class) {
				case "show_modal":
					var template = "parentModal.html";
					break;
				default:
					var template = "defaultTask.html";
			}
			return template;
		}

		// Events Listener
		var createListener = $rootScope.$on('TaskCtrl.create', function (event, data) {
			ctrl.tasks.push(data.payload);
		});
		var createListener = $rootScope.$on('TaskCtrl.listCreate', function (event, data) {
			angular.forEach(data.payload, function(item, key) {
				ctrl.tasks.push(item);
			});
		});
		var updateListener = $rootScope.$on('TaskCtrl.update', function (event, data) {
			var position = ctrl.tasks.map(function(task){
				return task.id;
			}).indexOf(data.id);
			ctrl.tasks[position] = data;
		});
		var deleteListener = $rootScope.$on('TaskCtrl.destroy', function (event, data) {
			var position = ctrl.tasks.map(function(task){
				return task.id;
			}).indexOf(data.object.id);
			ctrl.tasks.splice(position,1);
		});

		$scope.$on('$destroy', function(){
			createListener();
			updateListener();
		});
	}
})();

(function(){
	'use strict';
	angular
	.module('myApp')
	.controller('TaskFormController', TaskFormController)
	TaskFormController.$inject = [
		'$rootScope',
		'$scope',
		'$uibModalInstance',
		'items',
		'TaskService',
		'TasktmplService',
		"$controller"
	];
		function TaskFormController(
			$rootScope,
			$scope,
			$uibModalInstance,
			items,
			TaskService,
			TasktmplService,
			$controller){

			var ctrl = this;

			//Get the default functionality
			var base = $controller('BaseFormCtrl', {$scope: $scope});

			angular.extend(this, base)

			if(items.bind != undefined)
			{
				ctrl.bind = items.bind;
			}
			ctrl.hasError = false;
			ctrl.errors = [];
			ctrl.payload = items.payload;
			var expectEvent = items.expect;
			console.log('expectEvent: ',expectEvent);

			var originalObj = angular.extend({}, items.bind);

			//methods
			ctrl.getTasks = function(bundleId){
				TaskService.getBundleTasks(bundleId)
				.then(function(res){
					ctrl.tasks = res;
				})
				.catch(function(err){
					console.error("ERROR RESPONDING FROM getTasks: ", err);
				});
			}

			ctrl.loadTemplates = function(modelType){
				TasktmplService.getAllTasktmplsByParent(modelType)
				.then(function(res){
					ctrl.templates = res;
					ctrl.loadUsers();
				})
				.catch(function(err){
					console.error("ERROR RESPONDING FROM getTasks: ", err);
				});
			}

			ctrl.loadUsers = function(){
				TaskService.getAllUsersByTaskParent(ctrl.bind.parentId, ctrl.bind.parentType)
				.then(function(res){
					ctrl.users = res;
				})
				.catch(function(err){
					console.error("ERROR RESPONDING FROM getTasks: ", err);
				});
			}

			ctrl.addTask = function(){
				var data = ctrl.bind
				TaskService.addTask(data)
				.then(function(res){
					ctrl.fireEvents(res);
					$uibModalInstance.close(res);
				})
				.catch(function(err){
					console.error("ERROR RESPONDING FROM addTask: ", err);
				});
			}

			ctrl.addTasks = function(){
				var data = {};
				data.tasks = [];
				data.parentType = ctrl.bind.parentType;
				data.parentId = ctrl.bind.parentId;
				angular.forEach(ctrl.templates, function(item, key) {
					if (item.addThis) {
						data.tasks.push(item);
					}
				});
				console.log('addTasks data:',data);
				TaskService.addTasks(data)
				.then(function(res){
					ctrl.fireEvents(res);
					$uibModalInstance.close(res);
				})
				.catch(function(err){
					if (err.status == 422) {
						ctrl.hasError = true;
						ctrl.errors = ctrl.processErrors(err.data);
					}
					console.error("ERROR RESPONDING FROM addTask: ", err);
				});
			}

			ctrl.updateTask = function(task){
				var data = ctrl.bind
				TaskService.updateTask(ctrl.bind.uid, data)
				.then(function(res){
					ctrl.fireEvents(res);
					$uibModalInstance.close(res);
				})
				.catch(function(err){
					if (err.status == 422) {
						ctrl.hasError = true;
						ctrl.errors = ctrl.processErrors(err.data);
					}
					console.error("ERROR RESPONDING FROM updateTask: ", err);
				});
			}

			ctrl.deleteTask = function (taskId, idx){
				if(confirm('Are you sure you want to delete this task?')){
					TaskService.deleteTask(taskId)
					.then(function(res){
						ctrl.tasks.splice(idx, 1);
						ctrl.fireEvents(res);
					})
					.catch(function(err){
						console.error("ERROR RESPONDING FROM GET ALL USERS: ", err);
					});
				}
			}

			ctrl.fireEvents = function(d){
				if(expectEvent != undefined && expectEvent != ''){
					$rootScope.$emit(expectEvent, d);
				}else{
				}
			}

			$scope.cancel = ctrl.cancel = function () {
				if(ctrl.bind != undefined) {}

				$uibModalInstance.dismiss('cancel');
		};
	}
})();
(function(){
	'use strict';
	angular
	.module('myApp')
	.controller('TaskUserModCtrl', TaskUserModCtrl)
	TaskUserModCtrl.$inject = [
		"$rootScope",
		"$scope",
		"TaskService",
		"$controller"
	];
	function TaskUserModCtrl(
		$rootScope,
		$scope,
		TaskService,
		$controller){

		var ctrl = this;
		//Get the default functionality
		var base = $controller('BaseCtrl', {$scope: $scope});

		angular.extend(this, base)

		ctrl.columns 		= [
			{'class':'col-md-2','field':'memo','title':'Memo'},
			{'class':'col-md-2','field':'details','title':'Details'},
			{'class':'col-md-2','field':'notes','title':'Notes'},
			{'class':'col-md-2','field':'completed_details','title':'Completed_details'},
			{'class':'col-md-2','field':'created_by','title':'Created_by'},
			{'class':'col-md-2','field':'assigned_to','title':'Assigned_to'},
			{'class':'col-md-2','field':'due_on','title':'Due_on'},
			{'class':'col-md-2','field':'completed_on','title':'Completed_on'}
		];

		//methods
		ctrl.loadUserTasks = function(userId){
			TaskService.getAllTasksByUser(userId)
			.then(function(res){
				ctrl.tasks = res;
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM getTasks: ", err);
			});
		}

		ctrl.getTasks = function(){
			TaskService.getAllTasks()
			.then(function(res){
				ctrl.tasks = res;
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM getTasks: ", err);
			});
		}

		ctrl.deleteTask= function (taskId, idx){
			if(confirm('Are you sure you want to delete this task?')){
				TaskService.deleteTask(taskId)
				.then(function(res){
					ctrl.tasks.splice(idx, 1);
					$rootScope.$emit('ChangeCtrl.reload');
				})
				.catch(function(err){
					console.error("ERROR RESPONDING FROM GET ALL USERS: ", err);
				});
			}
		}

		ctrl.completeTask= function (task, idx){
			task.completed_on = moment().format('YYYY-MM-DD HH:mm:ss');
			task.add_change_record = "complete";
			TaskService.updateTask(task.id,task)
			.then(function(res){
				delete task.add_change_record;
				$rootScope.$emit('ChangeCtrl.reload');
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM GET ALL USERS: ", err);
			});
		}

		ctrl.resetTask= function (task, idx){
			if(confirm('Are you sure you want to reset this task?')){
				task.completed_on = null;
				task.add_change_record = "reset";
				TaskService.updateTask(task.id,task)
				.then(function(res){
					delete task.add_change_record;
					$rootScope.$emit('ChangeCtrl.reload');
				})
				.catch(function(err){
					console.error("ERROR RESPONDING FROM GET ALL USERS: ", err);
				});
			}
		}

		// Events Listener
		var createListener = $rootScope.$on('TaskUserModCtrl.create', function (event, data) {
			ctrl.tasks.push(data.payload);
		});
		var createListener = $rootScope.$on('TaskUserModCtrl.listCreate', function (event, data) {
			angular.forEach(data.payload, function(item, key) {
				ctrl.tasks.push(item);
			});
		});
		var updateListener = $rootScope.$on('TaskUserModCtrl.update', function (event, data) {
			var position = ctrl.tasks.map(function(task){
				return task.id;
			}).indexOf(data.id);
			ctrl.tasks[position] = data;
		});
		var deleteListener = $rootScope.$on('TaskUserModCtrl.destroy', function (event, data) {
			var position = ctrl.tasks.map(function(task){
				return task.id;
			}).indexOf(data.object.id);
			ctrl.tasks.splice(position,1);
		});

		$scope.$on('$destroy', function(){
			createListener();
			updateListener();
		});
	}
})();

(function(){
	'use strict';
	angular
	.module('myApp')
	.controller('TasktmplCtrl', TasktmplCtrl)
	TasktmplCtrl.$inject = [
		"$rootScope",
		"$scope",
		"TasktmplService",
		"$controller"
	];
	function TasktmplCtrl(
		$rootScope,
		$scope,
		TasktmplService,
		$controller
	){
		var ctrl = this;

		//Get the default functionality
		var base = $controller('BaseCtrl', {$scope: $scope});

		angular.extend(this, base)

		ctrl.columns 			= [
			{'class':'col-md-2','field':'memo','title':'Memo'},
			{'class':'col-md-1','field':'type','title':'Type'},
			{'class':'col-md-1','field':'priority','title':'Priority'},
			{'class':'col-md-2','field':'category','title':'Category'},
			{'class':'col-md-5','field':'details','title':'Details'},
		];
		ctrl.modColumns 			= [
			{'class':'col-md-2','field':'memo','title':'Memo'},
			{'class':'col-md-1','field':'type','title':'Type'},
			{'class':'col-md-1','field':'priority','title':'Priority'},
			{'class':'col-md-2','field':'category','title':'Category'},
			{'class':'col-md-5','field':'details','title':'Details'},
		];
		ctrl.orderField 		= ctrl.columns[0];
		ctrl.tasktmpls			= [];
		ctrl.tasktmpl			= {};
		ctrl.isTabulated= true;
		ctrl.showSearch = false;


		// get all Tasktmpls
		ctrl.getTasktmpls = function(){
			TasktmplService.getAllTasktmpls(ctrl.searchDB)
			.then(function(res){
				ctrl.tasktmpls = res.data;
				ctrl.sortBy(ctrl.orderField.field);
				ctrl.tasktmplCount = res.count;
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM getTasktmpls: ", err);
			});
		}

		// get all Tasktmpls for a specific parent
		ctrl.getParentTasktmpls = function(parentId,parentType){
			ctrl.parentId = parentId;
			ctrl.parentType = parentType;
			TasktmplService.getAllTasktmplsByParent(parentId,parentType)
			.then(function(res){
				ctrl.tasktmpls = res;
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM getTasktmpls: ", err);
			});
		}

		// get a specific Tasktmpl
		ctrl.getTasktmpl = function(tasktmplId){
			TasktmplService.getTasktmpl(tasktmplId)
			.then(function(res){
				ctrl.tasktmpl = res;
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM getTasktmpls: ", err);
			});
		}

		// delete a specific Tasktmpl
		ctrl.deleteTasktmpl= function (tasktmpl){
			if(confirm('Are you sure you want to delete this tasktmpl?')){
				TasktmplService.deleteTasktmpl(tasktmpl.uid)
				.then(function(res){
					var position = ctrl.tasktmpls.map(function(tasktmpl){
						return tasktmpl.id;
					}).indexOf(tasktmpl.id);
					ctrl.tasktmpls.splice(position, 1);
					ctrl.fireEvents(res);
				})
				.catch(function(err){
					console.error("ERROR RESPONDING FROM GET ALL USERS: ", err);
				});
			}
		}

		// Search all Tasktmpls
		ctrl.searchTasktmpls = function(){
			TasktmplService.getAllTasktmpls(ctrl.searchDB)
			.then(function(res){
				ctrl.tasktmpls = res.data;
				ctrl.tasktmplCount = res.count;
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM searchTasktmpls: ", err);
			});
		}

		// Events Listeners
		var createListener = $rootScope.$on('TasktmplCtrl.create', function (event, data) {
			ctrl.tasktmpls.push(data.payload);
		});
		var updateListener = $rootScope.$on('TasktmplCtrl.update', function (event, data) {
			var position = ctrl.tasktmpls.map(function(tasktmpl){
				return tasktmpl.id;
			}).indexOf(data.id);
			ctrl.tasktmpls[position] = data;
		});
		var deleteListener = $rootScope.$on('TasktmplCtrl.destroy', function (event, data) {
			var position = ctrl.tasktmpls.map(function(tasktmpl){
				return tasktmpl.id;
			}).indexOf(data.object.id);
			ctrl.tasktmpls.splice(position,1);
		});

		$scope.$on('$destroy', function(){
			createListener();
			updateListener();
		});
	}
})();
(function(){
	'use strict';
	angular
	.module('myApp')
	.controller('TemplateCtrl', TemplateCtrl)
	TemplateCtrl.$inject = ["$rootScope","$scope","$http","$filter","$uibModal","TemplateService","$controller"];
	function TemplateCtrl($rootScope,$scope, $http, $filter, $uibModal, TemplateService, $controller){
		var ctrl = this;

		//Get the default functionality
		var base = $controller('BaseCtrl', {$scope: $scope});

		angular.extend(this, base)

		ctrl.columns 			= [
			{'class':'col-md-2','field':'model','title':'Model'},
			{'class':'col-md-9','field':'data','title':'Data'},
		];
		ctrl.modColumns 			= [
			{'class':'col-md-2','field':'model','title':'Model'},
			{'class':'col-md-9','field':'data','title':'Data'},
		];
		ctrl.orderField 		= ctrl.columns[0];
		ctrl.templates			= [];
		ctrl.template			= {};
		ctrl.isTabulated= true;
		ctrl.showSearch = false;


		// get all Templates
		ctrl.getTemplates = function(){
			TemplateService.getAllTemplates(ctrl.searchDB)
			.then(function(res){
				ctrl.templates = res.data;
				ctrl.sortBy(ctrl.orderField.field);
				ctrl.templateCount = res.count;
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM getTemplates: ", err);
			});
		}

		// get all Templates for a specific parent
		ctrl.getParentTemplates = function(parentId,parentType){
			ctrl.parentId = parentId;
			ctrl.parentType = parentType;
			TemplateService.getAllTemplatesByParent(parentId,parentType)
			.then(function(res){
				ctrl.templates = res;
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM getTemplates: ", err);
			});
		}

		// get a specific Template
		ctrl.getTemplate = function(templateId){
			TemplateService.getTemplate(templateId)
			.then(function(res){
				ctrl.template = res;
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM getTemplates: ", err);
			});
		}

		// delete a specific Template
		ctrl.deleteTemplate= function (template){
			if(confirm('Are you sure you want to delete this template?')){
				TemplateService.deleteTemplate(template.uid)
				.then(function(res){
					var position = ctrl.templates.map(function(template){
						return template.id;
					}).indexOf(template.id);
					ctrl.templates.splice(position, 1);
					ctrl.fireEvents(res);
				})
				.catch(function(err){
					console.error("ERROR RESPONDING FROM GET ALL USERS: ", err);
				});
			}
		}

		// Search all Templates
		ctrl.searchTemplates = function(){
			TemplateService.getAllTemplates(ctrl.searchDB)
			.then(function(res){
				ctrl.templates = res.data;
				ctrl.templateCount = res.count;
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM searchTemplates: ", err);
			});
		}

		ctrl.isNumber= function (n) {
			return !isNaN(parseFloat(n)) && isFinite(n);
		}

		// Events Listeners
		var createListener = $rootScope.$on('TemplateCtrl.create', function (event, data) {
			ctrl.templates.push(data);
		});
		var updateListener = $rootScope.$on('TemplateCtrl.update', function (event, data) {
			var position = ctrl.templates.map(function(template){
				return template.id;
			}).indexOf(data.id);
			ctrl.templates[position] = data;
		});
		var deleteListener = $rootScope.$on('TemplateCtrl.destroy', function (event, data) {
			var position = ctrl.templates.map(function(template){
				return template.id;
			}).indexOf(data.object.id);
			ctrl.templates.splice(position,1);
		});

		$scope.$on('$destroy', function(){
			createListener();
			updateListener();
		});
	}
})();
(function(){
	'use strict';
	angular
	.module('myApp')
	.controller('TemplateFormController', TemplateFormController)
	TemplateFormController.$inject = ['$rootScope','$scope', '$http', '$filter' ,'$uibModal', '$uibModalInstance', 'items', 'FileUploadService', 'TemplateService',"$controller"];
		function TemplateFormController($rootScope,$scope, $http, $filter, $uibModal, $uibModalInstance, items, FileUploadService, TemplateService, $controller){

			var ctrl = this;

			//Get the default functionality for modal form
			var base = $controller('BaseFormCtrl', {$scope: $scope});

			angular.extend(this, base);

			if((items != undefined)&&(items.bind != undefined)) {
				console.log('items.bind:',items.bind);
				ctrl.bind = items.bind.data;
				ctrl.bind.id = items.bind.id;
				ctrl.bind.uid = items.bind.uid;
				ctrl.originalObj = angular.extend({}, items.bind);
			}

			if((items != undefined)&&(items.expect != undefined)) {
				ctrl.expectEvent = items.expect;
			}
			ctrl.addTemplate = function(){
				var data = ctrl.bind
				TemplateService.addTemplate(data)
				.then(function(res){
					ctrl.fireEvents(res);
					$uibModalInstance.close(res);
				})
				.catch(function(err){
					if (err.status == 422) {
						ctrl.hasError = true;
						ctrl.errors = ctrl.processErrors(err.data);
					}
					console.error("ERROR RESPONDING FROM addTemplate: ", err);
				});
			}

			ctrl.updateTemplate= function(){
				var data = ctrl.bind
				if(ctrl.assigned_parent.originalObject != undefined) {
					data.parent_id = ctrl.assigned_parent.originalObject.id
				}
				TemplateService.updateTemplate(ctrl.bind.uid, data)
				.then(function(res){
					ctrl.fireEvents(res);
					$uibModalInstance.close(res);
				})
				.catch(function(err){
					console.error("ERROR RESPONDING FROM updateTemplate: ", err);
				});
			}

			ctrl.deleteTemplate = function(templateId, idx){
				var data = ctrl.bind
				TemplateService.deleteTemplate(templateId)
				.then(function(res){
					ctrl.templates.splice(idx, 1);
					ctrl.fireEvents(res);
				})
				.catch(function(err){
					console.error("ERROR RESPONDING FROM deleteTemplate: ", err);
				});
			}

			ctrl.fireEvents = function (d) {
				if (ctrl.expectEvent != undefined && ctrl.expectEvent != '') {
					$rootScope.$emit(ctrl.expectEvent, d);
				} else {
					//
				}
			}

			$scope.ok = ctrl.addTemplate;

			$scope.cancel = function () {
				if(ctrl.bind != undefined) {
					// angular.extend(ctrl.bind, originalObj);
				}
				$uibModalInstance.dismiss('cancel');
			};
	}
})();
(function(){
	'use strict';
	angular
	.module('myApp')
	.controller('TimelineListCtrl', TimelineListCtrl)
	TimelineListCtrl.$inject = ["$rootScope","$scope","$http","$filter","$uibModal","TimelineService","$controller"];
	function TimelineListCtrl($rootScope,$scope, $http, $filter, $uibModal, TimelineService, $controller){

		var ctrl = this;
		//Get the default functionality
		var base = $controller('BaseCtrl', {$scope: $scope});

		angular.extend(this, base)

		ctrl.columns 			= [
			{'class':'col-md-2','field':'title','title':'Title'},
			{'class':'col-md-2','field':'description','title':'Description'},
			{'class':'col-md-2','field':'timelineable','title':'Timelineable'}
		];

		//methods
		ctrl.getTimelines = function(){
			TimelineService.getAllTimelines(ctrl.searchDB)
			.then(function(res){
				ctrl.timelines = res.data;
				ctrl.timelineCount = res.count;
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM getTimelines: ", err); 
			});
		}

		ctrl.deleteTimeline= function (timelineId, idx){
			if(confirm('Are you sure you want to delete this timeline?')){
				TimelineService.deleteTimeline(timelineId)
				.then(function(res){
					ctrl.timelines.splice(idx, 1);
					ctrl.fireEvents(res);
				})
				.catch(function(err){
					console.error("ERROR RESPONDING FROM GET ALL USERS: ", err); 
				});
			}
		}

		// Events Listener
		var createListener = $rootScope.$on('TimelineListCtrl.create', function (event, data) {
			ctrl.timelines.push(data.payload);
		});
		var updateListener = $rootScope.$on('TimelineListCtrl.update', function (event, data) {
			// do nothing
		});
		var deleteListener = $rootScope.$on('TimelineListCtrl.destroy', function (event, data) {
			var position = ctrl.timelines.map(function(timeline){
				return timeline.id;
			}).indexOf(data.object.id);
			ctrl.timelines.splice(position,1);
		});
		
		$scope.$on('$destroy', function(){
			createListener();
			updateListener();
		});
	}
})();
(function(){
	'use strict';
	angular
	.module('myApp')
	.controller('TimelineModCtrl', TimelineModCtrl)
	TimelineModCtrl.$inject = ["$rootScope","$scope","$http","$filter","$uibModal","TimelineService","$controller"];
	function TimelineModCtrl($rootScope,$scope, $http, $filter, $uibModal, TimelineService, $controller){

		var ctrl = this;
		//Get the default functionality
		var base = $controller('BaseCtrl', {$scope: $scope});

		angular.extend(this, base)

		ctrl.columns 		= [
			{'class':'col-md-2','field':'title','title':'Title'},
			{'class':'col-md-2','field':'description','title':'Description'},
			{'class':'col-md-2','field':'timelineable','title':'Timelineable'}
		];

		//methods
		ctrl.loadParentTimeline = function(parentId,parentType){
			ctrl.parentId = parentId;
			ctrl.parentType = parentType;
			TimelineService.getAllTimelines(ctrl.parentId,ctrl.parentType)
			.then(function(res){
				ctrl.timelines = res;
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM getTimelines: ", err); 
			});
		}

		ctrl.loadTimeline = function(){
			TimelineService.getAllTimelines()
			.then(function(res){
				ctrl.timelines = res;
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM getTimelines: ", err); 
			});
		}

		ctrl.getTimelines = function(){
			TimelineService.getAllTimelines()
			.then(function(res){
				ctrl.timelines = res;
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM getTimelines: ", err); 
			});
		}

		ctrl.deleteTimeline= function (timelineId, idx){
			if(confirm('Are you sure you want to delete this timeline?')){
				TimelineService.deleteTimeline(timelineId)
				.then(function(res){
					ctrl.timelines.splice(idx, 1);
					ctrl.fireEvents(res);
				})
				.catch(function(err){
					console.error("ERROR RESPONDING FROM GET ALL USERS: ", err); 
				});
			}
		}

		// Events Listener
		var createListener = $rootScope.$on('TimelineModCtrl.create', function (event, data) {
			ctrl.timelines.push(data.payload);
		});
		var updateListener = $rootScope.$on('TimelineModCtrl.update', function (event, data) {
			// do nothing
		});
		var deleteListener = $rootScope.$on('TimelineModCtrl.destroy', function (event, data) {
			var position = ctrl.timelines.map(function(timeline){
				return timeline.id;
			}).indexOf(data.object.id);
			ctrl.timelines.splice(position,1);
		});
		
		$scope.$on('$destroy', function(){
			createListener();
			updateListener();
		});
	}
})();

(function(){
	'use strict';
	angular
	.module('myApp')
	.controller('TimelineViewCtrl', TimelineViewCtrl)
	TimelineViewCtrl.$inject = ["$rootScope","$scope","$http","$filter","$uibModal","TimelineService","$controller"];
	function TimelineViewCtrl($rootScope,$scope, $http, $filter, $uibModal, TimelineService, $controller){

		var ctrl = this;
		//Get the default functionality
		var base = $controller('BaseCtrl', {$scope: $scope});

		angular.extend(this, base)

		ctrl.columns 		= [
			{'class':'col-md-2','field':'title','title':'Title'},
			{'class':'col-md-2','field':'description','title':'Description'},
			{'class':'col-md-2','field':'timelineable','title':'Timelineable'}
		];

		//methods
		ctrl.loadTimeline = function(timelineId){
			TimelineService.getTimeline(timelineId)
			.then(function(res){
				ctrl.timeline = res;
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM getTimelines: ", err); 
			});
		}

		ctrl.getTimelines = function(){
			TimelineService.getAllTimelines()
			.then(function(res){
				ctrl.timelines = res;
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM getTimelines: ", err); 
			});
		}

		ctrl.deleteTimeline= function (timelineId, idx){
			if(confirm('Are you sure you want to delete this timeline?')){
				TimelineService.deleteTimeline(timelineId)
				.then(function(res){
					ctrl.timelines.splice(idx, 1);
					ctrl.fireEvents(res);
				})
				.catch(function(err){
					console.error("ERROR RESPONDING FROM GET ALL USERS: ", err); 
				});
			}
		}

		// Events Listener
		var createListener = $rootScope.$on('TimelineViewCtrl.create', function (event, data) {
			ctrl.timelines.push(data.payload);
		});
		var updateListener = $rootScope.$on('TimelineViewCtrl.update', function (event, data) {
			// do nothing
		});
		var deleteListener = $rootScope.$on('TimelineViewCtrl.destroy', function (event, data) {
			var position = ctrl.timelines.map(function(timeline){
				return timeline.id;
			}).indexOf(data.object.id);
			ctrl.timelines.splice(position,1);
		});
		
		$scope.$on('$destroy', function(){
			createListener();
			updateListener();
		});
	}
})();

(function(){
	'use strict';
	angular
	.module('myApp')
	.controller('TimesheetCtrl', TimesheetCtrl)
	TimesheetCtrl.$inject = [
		"$rootScope",
		"$scope",
		"TimesheetService",
		"$controller",
		"$interval"
	];
	function TimesheetCtrl(
		$rootScope,
		$scope,
		TimesheetService,
		$controller,
		$interval
		 ){

		var ctrl = this;
		//Get the default functionality
		var base = $controller('BaseCtrl', {$scope: $scope});

		angular.extend(this, base)
		
		ctrl.columns 			= [
			{'class':'col-md-1','field':'duration','title':'Duration'},
			{'class':'col-md-2','field':'start_time','title':'Started'},
			{'class':'col-md-2','field':'end_time','title':'Ended'},
			{'class':'col-md-3','field':'details','title':'Details'},
			{'class':'col-md-2','field':'user.fullname','title':'User'},
		];

		ctrl.modColumns = [
			{ 'class': 'col-md-1', 'field': 'start_time', 'title': 'Duration' },
			{ 'class': 'col-md-4', 'field': 'user.fullname', 'title': 'User' },
			{ 'class': 'col-md-6', 'field': 'start_time', 'title': 'Start-End' },
		];

		ctrl.modSummaryColumns = [
			{ 'class': 'col-md-1', 'field': 'start_time', 'title': 'Duration' },
			{ 'class': 'col-md-4', 'field': 'user.fullname', 'title': 'User' },
			{ 'class': 'col-md-6', 'field': 'process', 'title': '' },
		];

		ctrl.modUserColumns = [
			{ 'class': 'col-md-1', 'field': 'start_time', 'title': 'Duration' },
			{ 'class': 'col-md-4', 'field': '', 'title': '' },
			{ 'class': 'col-md-6', 'field': '', 'title': 'Start-End' },
		];

		ctrl.timesheet = {};
		ctrl.timesheets = [];
		ctrl.timesheetSummaries = [];
		ctrl.open_timesheets = [];

		//methods
		ctrl.getParentTimesheets = function (parentId, parentType) {
			ctrl.parentId = parentId;
			ctrl.parentType = parentType;
			TimesheetService.getAllTimesheetsByParent(ctrl.parentId, ctrl.parentType)
				.then(function (res) {
					ctrl.timesheets = res;
					ctrl.getOpenTimesheets(ctrl.parentId, ctrl.parentType);
					ctrl.isLoaded = true;
				})
				.catch(function (err) {
					console.error("ERROR RESPONDING FROM getTimesheets: ", err);
				});
			TimesheetService.getAllOpenTimesheetsByParent(parentId, parentType)
				.then(function (res) {
					ctrl.open_timesheets = res;
					ctrl.isLoaded = true;
				})
				.catch(function (err) {
					console.error("ERROR RESPONDING FROM getTimesheets: ", err);
				});
		}

		ctrl.getTimesheetSummary = function (parentId, parentType) {
			ctrl.parentId = parentId;
			ctrl.parentType = parentType;
			TimesheetService.getGroupedTimesheetsByParent(parentId, parentType, 'user_id')
				.then(function (res) {
					ctrl.timesheetSummaries = res;
					ctrl.isLoaded = true;
				})
				.catch(function (err) {
					console.error("ERROR RESPONDING FROM getTimesheets: ", err);
				});
		}

		ctrl.getTimesheetUserSummary = function (userId) {
			ctrl.userId = userId;
			TimesheetService.getGroupedTimesheetsByUser(userId, 'timesheetable')
				.then(function (res) {
					ctrl.getUserOpenTimesheets(ctrl.userId);
					ctrl.timesheetSummaries = res;
					ctrl.isLoaded = true;
				})
				.catch(function (err) {
					console.error("ERROR RESPONDING FROM getTimesheets: ", err);
				});
		}

		ctrl.getOpenTimesheets = function (parentId, parentType) {
			ctrl.parentId = parentId;
			ctrl.parentType = parentType;
			TimesheetService.getAllOpenTimesheetsByParent(parentId, parentType)
				.then(function (res) {
					ctrl.open_timesheets = res;
					ctrl.isLoaded = true;
				})
				.catch(function (err) {
					console.error("ERROR RESPONDING FROM getTimesheets: ", err);
				});
		}

		ctrl.getUserOpenTimesheets = function (userId) {
			ctrl.userId = userId;
			TimesheetService.getAllOpenTimesheetsByUser(userId)
				.then(function (res) {
					ctrl.open_timesheets = res;
					ctrl.isLoaded = true;
				})
				.catch(function (err) {
					console.error("ERROR RESPONDING FROM getTimesheets: ", err);
				});
		}

		ctrl.getUserTimesheets = function (userId) {
			ctrl.userId = userId;
			TimesheetService.getAllTimesheetsByUser(userId)
				.then(function (res) {
					ctrl.timesheets = res;
					ctrl.isLoaded = true;
				})
				.catch(function (err) {
					console.error("ERROR RESPONDING FROM getTimesheets: ", err);
				});
		}

		ctrl.deleteTimesheet = function (timesheetId, idx) {
			if (confirm('Are you sure you want to delete this timesheet?')) {
				TimesheetService.deleteTimesheet(timesheetId)
					.then(function (res) {
						ctrl.timesheets.splice(idx, 1);
						ctrl.fireEvents(res);
					})
					.catch(function (err) {
						console.error("ERROR RESPONDING FROM GET ALL USERS: ", err);
					});
			}
		}

		ctrl.getTimesheet = function (timesheetId) {
			TimesheetService.getTimesheet(timesheetId)
				.then(function (res) {
					ctrl.timesheet = res;
					ctrl.isLoaded = true;
				})
				.catch(function (err) {
					console.error("ERROR RESPONDING FROM getTimesheets: ", err);
				});
		}

		ctrl.getTimesheets = function(){
			TimesheetService.getAllTimesheets()
			.then(function(res){
				ctrl.timesheets = res;
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM getTimesheets: ", err); 
			});
		}

		ctrl.searchTimesheets = function(){
			TimesheetService.searchTimesheets()
			.then(function(res){
				ctrl.timesheets = res;
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM getTimesheets: ", err); 
			});
		}

		ctrl.startTimer = function () {
			var data = {
				parentId: ctrl.parentId,
				parentType :ctrl.parentType,
			};
			TimesheetService.addTimesheet(data)
				.then(function (res) {
					ctrl.open_timesheets.push(res);
					ctrl.isLoaded = true;
				})
				.catch(function (err) {
					console.error("ERROR RESPONDING FROM getTimesheets: ", err);
				});
		}

		ctrl.stopTimer = function (timesheet) {
			var data = {
				stopTimer: true,
			};
			var position = ctrl.timesheets.map(function (timesheet) {
				return timesheet.id;
			}).indexOf(timesheet.id);
			ctrl.open_timesheets.splice(position, 1);
			// ctrl.timesheets.push(timesheet);
			TimesheetService.updateTimesheet(timesheet.uid, data)
				.then(function (res) {
					ctrl.timesheets.unshift(res);
					ctrl.getTimesheetSummary(ctrl.parentId, ctrl.parentType)
					ctrl.isLoaded = true;
				})
				.catch(function (err) {
					ctrl.open_timesheets.push(res);
					console.error("ERROR RESPONDING FROM getTimesheets: ", err);
				});
		}

		ctrl.deleteTimesheet= function (timesheet){
			if(confirm('Are you sure you want to delete this timesheet?')){
				TimesheetService.deleteTimesheet(timesheet.uid)
				.then(function(res){
					var position = ctrl.timesheets.map(function (timesheet) {
						return timesheet.id;
					}).indexOf(res.id);
					ctrl.timesheets.splice(position, 1);
					ctrl.fireEvents(res);
				})
				.catch(function(err){
					console.error("ERROR RESPONDING FROM GET ALL USERS: ", err); 
				});
			}
		}
		
		//Put in interval, first trigger after 60 seconds 
		ctrl.theInterval = $interval(function () {
			if (ctrl.userId == undefined) {
				ctrl.getOpenTimesheets(ctrl.parentId, ctrl.parentType);
			} else {
				ctrl.getUserOpenTimesheets(ctrl.userId);
			}
		}.bind(this), 60000);

		$scope.$on('$destroy', function () {
			$interval.cancel(ctrl.theInterval)
		});
		
		// Events Listener
		var createListener = $rootScope.$on('TimesheetCtrl.create', function (event, data) {
			ctrl.timesheets.push(data.payload);
		});
		var updateListener = $rootScope.$on('TimesheetCtrl.update', function (event, data) {
			// do nothing
		});
		var createListener = $rootScope.$on('TimesheetCtrl.refresh', function (event, data) {
			ctrl.getTimesheets();
		});
		var deleteListener = $rootScope.$on('TimesheetCtrl.destroy', function (event, data) {
			var position = ctrl.timesheets.map(function(timesheet){
				return timesheet.id;
			}).indexOf(data.object.id);
			ctrl.timesheets.splice(position,1);
		});
		
		$scope.$on('$destroy', function(){
			createListener();
			updateListener(); 
			$interval.cancel(theInterval)
		});
	}
})();
(function(){
	'use strict';
	angular
	.module('myApp')
	.controller('TypifierCtrl', TypifierCtrl)
	TypifierCtrl.$inject = ["$rootScope","$scope","TypifierService","$controller"];
	function TypifierCtrl($rootScope,$scope, TypifierService, $controller){
		var ctrl = this;

		//Get the default functionality
		var base = $controller('BaseCtrl', {$scope: $scope});

		angular.extend(this, base)

		ctrl.columns 			= [
			{'class':'col-md-1','field':'type','title':'Type'},
			{'class':'col-md-1','field':'category','title':'Category'},
			{'class':'col-md-1','field':'model','title':'Model'},
			{'class':'col-md-8','field':'description','title':'Description'},
		];
		ctrl.orderField 	= 'type';
		ctrl.typifiers		= [];
		ctrl.typifier		= {};
		ctrl.isTabulated	= true;


		// get all Typifiers
		ctrl.getTypifiers = function(){
			TypifierService.getAllTypifiers(ctrl.searchDB)
			.then(function(res){
				ctrl.typifiers = res.data;
				ctrl.sortBy(ctrl.orderField.field);
				ctrl.typifierCount = res.count;
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM getTypifiers: ", err); 
			});
		}

		// get all Typifiers for a specific parent
		ctrl.getTypifiersModule = function(parentId,parentType){
			ctrl.parentId = parentId;
			ctrl.parentType = parentType;
			TypifierService.getAllTypifiersByParent(parentId,parentType)
			.then(function(res){
				ctrl.typifiers = res;
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM getTypifiers: ", err); 
			});
		}

		// get a specific Typifier
		ctrl.getTypifier = function(typifierId){
			TypifierService.getTypifier(typifierId)
			.then(function(res){
				ctrl.typifier = res;
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM getTypifiers: ", err); 
			});
		}

		// delete a specific Typifier
		ctrl.deleteTypifier= function (typifierId, idx){
			if(confirm('Are you sure you want to delete this typifier?')){
				TypifierService.deleteTypifier(typifierId)
				.then(function(res){
					ctrl.typifiers.splice(idx, 1);
					ctrl.fireEvents(res);
				})
				.catch(function(err){
					console.error("ERROR RESPONDING FROM GET ALL USERS: ", err); 
				});
			}
		}

		// Search all Typifiers
		ctrl.searchTypifiers = function(){
			TypifierService.getAllTypifiers(ctrl.searchDB)
			.then(function(res){
				ctrl.typifiers = res;
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM searchTypifiers: ", err); 
			});
		}

		// Events Listeners
		var createListener = $rootScope.$on('TypifierCtrl.create', function (event, data) {
			ctrl.typifiers.push(data.payload);
		});
		var updateListener = $rootScope.$on('TypifierCtrl.update', function (event, data) {
			var position = ctrl.typifiers.map(function(typifier){
				return typifier.id;
			}).indexOf(data.id);
			ctrl.typifiers[position] = data;
		});
		var deleteListener = $rootScope.$on('TypifierCtrl.destroy', function (event, data) {
			var position = ctrl.typifiers.map(function(typifier){
				return typifier.id;
			}).indexOf(data.object.id);
			ctrl.typifiers.splice(position,1);
		});
		
		$scope.$on('$destroy', function(){
			createListener();
			updateListener();
		});
	}
})();
(function () {
	'use strict';
	angular
		.module('myApp')
		.controller('UserCtrl_DEP', UserCtrl_DEP)
	UserCtrl_DEP.$inject = [
		"$rootScope",
		"$scope",
		"UserService",
		"RoleService",
		"$controller"
	];
	function UserCtrl_DEP(
		$rootScope,
		$scope,
		UserService,
		RoleService,
		$controller
	) {

		var ctrl = this;

		//Get the default functionality
		var base = $controller('BaseCtrl', { $scope: $scope });

		angular.extend(this, base)

		//member data
		ctrl.roles = [],
			ctrl.columns = [
			{ 'class': 'col-sm-2', 'field': 'fullname', 'title': 'Name' },
			{ 'class': 'col-sm-2', 'field': 'email', 'title': 'Email' },
			{ 'class': 'col-sm-2', 'field': 'mobile_number', 'title': 'Mobile' },
			{ 'class': 'col-sm-4', 'field': 'registered_at', 'title': 'Registered Date' }
		];
		ctrl.modColumns = [
			{ 'class': 'col-sm-2', 'field': 'fullname', 'title': 'Name' },
			{ 'class': 'col-sm-2', 'field': 'email', 'title': 'Email' },
			{ 'class': 'col-sm-2', 'field': 'mobile_number', 'title': 'Mobile' },
			{ 'class': 'col-sm-4', 'field': 'created_at', 'title': 'Registered Date' }
		];
		ctrl.isTabulated = true;
		ctrl.showSearch = true;

		//methods
		ctrl.loadUsers = function () {
			ctrl.isLoaded = false;
			UserService.getAllUsers()
				.then(function (res) {
					ctrl.users = res.data;
					ctrl.userCount = res.count;
					ctrl.loadRoles();
					ctrl.isLoaded = true;
				})
				.catch(function (err) {
					console.error("ERROR RESPONDING FROM getDepartments: ", err);
				});
		}

		ctrl.loadUser = function (userId) {
			ctrl.userId = userId;
			UserService.getUser(ctrl.userId)
				.then(function (res) {
					ctrl.user = res;
					ctrl.isLoaded = true;
				})
				.catch(function (err) {
					console.error("ERROR RESPONDING FROM getUser: ", err);
				});
		};

		// get all Users for a specific parent
		ctrl.getUsersModule = function(parentId,parentType){
			ctrl.parentId = parentId;
			ctrl.parentType = parentType;
			UserService.getAllUsersByParent(parentId,parentType)
			.then(function(res){
				ctrl.users = res;
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM getUsers: ", err);
			});
		}

		ctrl.loadRoles = function () {
			ctrl.isLoaded = false;
			RoleService.getAllRoles()
				.then(function (res) {
					ctrl.roles = res;
				})
				.catch(function (err) {
					console.error("ERROR RESPONDING FROM getDepartments: ", err);
				});
		}
		// Search all Donors
		ctrl.searchUsers = function () {
			UserService.getAllUsers(ctrl.searchDB)
				.then(function (res) {
					ctrl.users = res.data;
					ctrl.userCount = res.count;
					ctrl.searchQry.$ = '';
					ctrl.isLoaded = true;
				})
				.catch(function (err) {
					console.error("ERROR RESPONDING FROM searchUsers: ", err);
				});
		}


		ctrl.deleteUser = function (user) {
			if (confirm('Are you certain you want to delete this user?')) {
				UserService.deleteUser(user.uid)
					.then(function (res) {
						var position = ctrl.users.map(function(user){
							return user.id;
						}).indexOf(res.id);
						ctrl.users.splice(position, 1);
					})
					.catch(function (err) {
						console.error("ERROR RESPONDING FROM deleteUser: ", err);
					});
			}
		}

		ctrl.changeUserPermission = function (role, user) {

			var permission = user.permissions[role.name] ? false : true;

			var post_data = {
				'user_id': user.id,
				'role_id': role.id,
			};
			// if this is true, we should be removing it
			if (!permission) {
				UserService.detachRole(post_data)
					.then(function (res) {
						user.permissions[role.name] = false;
					})
					.catch(function (err) {
						console.error("ERROR RESPONDING FROM attachRole: ", err);
						user.permissions[role.name] = true;
					});
			} else {
				UserService.attachRole(post_data)
					.then(function (res) {
						user.permissions[role.name] = true;
					})
					.catch(function (err) {
						console.error("ERROR RESPONDING FROM attachRole: ", err);
						user.permissions[role.name] = false;
					});
			}
		};

		// delete a specific Engagement
		ctrl.remove = function (user, parentId, parentType){
			if(confirm('Are you sure you want to remove this user?')){
				var data = {
					parentId:parentId,
					parentType:parentType,
					userId:user.id,
				};
				// return
				UserService.detachUserFromParent(data)
				.then(function(res){
					var position = ctrl.users.map(function(user){
						return user.id;
					}).indexOf(res.id);
					ctrl.users.splice(position, 1);
				})
				.catch(function(err){
					console.error("ERROR RESPONDING FROM GET ALL USERS: ", err);
				});
			}
		}
		// Events Listener
		var createListener = $rootScope.$on('UserCtrl_DEP.create', function (event, data) {
			ctrl.users.push(data.payload);
		});
		var updateListener = $rootScope.$on('UserCtrl_DEP.update', function (event, data) {
			//do nothing
		});
		var deleteListener = $rootScope.$on('UserCtrl_DEP.delete', function (event, data) {
			var position = ctrl.users.map(function(user){
				return user.id;
			}).indexOf(data.id);
			ctrl.users.splice(position, 1);
		});
		var reloadListener = $rootScope.$on('UserCtrl_DEP.reload', function (event, data) {
			ctrl.loadUser(ctrl.userId);
		});

		$scope.$on('$destroy', function () {
			createListener();
			updateListener();
		});
	}
})();
(function(){
	'use strict';
	angular
	.module('myApp')
	.controller('UserViewCtrl', UserViewCtrl)
	UserViewCtrl.$inject = [
		'$rootScope',
		'$scope',
		'$http',
		'$filter',
		'$sce',
		"$controller",
		"UserService"
	 ];
	function UserViewCtrl($rootScope,
		$scope,
		$http,
		$filter,
		$sce,
		$controller,
		UserService
 	){

		var ctrl = this;
		var base = $controller('BaseCtrl', {$scope: $scope});
		angular.extend(this, base)

		ctrl.userId 		= '',
		ctrl.user 		= [],
		ctrl.states 		= [],
		ctrl.users 		= [],
		ctrl.peoplesearch = [],
		ctrl.peoplesearchcount = -1,
		ctrl.columns		 = [
			{'class':'col-sm-2','field':'last','title':'Last Name'},
			{'class':'col-sm-2','field':'first','title':'First Name'},
			{'class':'col-sm-2','field':'username','title':'Username'},
			{'class':'col-sm-2','field':'email','title':'Email'}
		];

		ctrl.loadUser = function(userId)
		{
			ctrl.userId = userId;
			UserService.getUser(ctrl.userId)
			.then(function(res){
				ctrl.user = res;
				ctrl.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM getUser: ", err); 
			});
		};

		ctrl.loadStates = function(){
			$http.get('/api/all-states')
			.then(function(data){
				ctrl.states = data;
			})
			.catch(function(err){
				console.error('Error occurred: ',err);
			});
		};


		ctrl.personSearch = function()
		{
			$data = {
				'first': ctrl.user.first,
				'last': ctrl.user.last,
				'city': ctrl.user.city,
				'state': ctrl.user.state
			};

			ctrl.isSearchDone = false;
			$http.post('/mvmnt-api/user-search', $data)
			.then(function(data){
				ctrl.peoplesearch = data.data;
				ctrl.peoplesearchcount = data.count;
				ctrl.isSearchDone = true;
			})
			.catch(function(err){
				console.error('Error occurred: ',err);
			});
		};

		// Events Listener
		var createListener = $rootScope.$on('UserViewCtrl.create', function (event, data) {
			$scope.tags.push(data.payload);
		});

		var updateListener = $rootScope.$on('UserViewCtrl.update', function (event, data) {
			//do nothing
		});

		var reloadListener = $rootScope.$on('UserViewCtrl.reload', function (event, data) {
			ctrl.loadUser(ctrl.userId);
		});

		//Events Listener
		$scope.$on('$destroy', function(){
			createListener();
			updateListener();
			reloadListener();
		});
	}
})();
(function(){
	'use strict';
	angular
	.module('myApp')
	.controller('UserListCtrl', UserListCtrl)
	UserListCtrl.$inject = ["$rootScope","$scope","$http","$filter","$uibModal","UserService","RoleService","$controller"];
	function UserListCtrl($rootScope,$scope, $http, $filter, $uibModal, UserService, RoleService, $controller){

		var ctrl = $controller('BaseCtrl', {$scope: $scope});

		//member data
		$scope.roles		= [],
		$scope.columns 		= [
				{'class':'col-sm-3','field':'last','title':'Name'},
				{'class':'col-sm-3','field':'email','title':'Email'},
				{'class':'col-sm-4','field':'created_at','title':'Registered Date'}
			];

		//methods
		$scope.loadUsers = function(){
			$scope.isLoaded = false;
			UserService.getAllUsers()
			.then(function(res){
				$scope.users = res;
				$scope.loadRoles();
				$scope.isLoaded = true;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM getDepartments: ", err);
			});
		}

		$scope.loadRoles = function(){
			$scope.isLoaded = false;
			RoleService.getAllRoles()
			.then(function(res){
				$scope.roles = res;
			})
			.catch(function(err){
				console.error("ERROR RESPONDING FROM getDepartments: ", err);
			});
		}

		$scope.deleteUser= function (id,idx){
			if(confirm('Are you certain you want to delete this user?'))
			{
				UserService.deleteUser(id)
				.then(function(res){
					$scope.users.splice(idx, 1);
				})
				.catch(function(err){
					console.error("ERROR RESPONDING FROM deleteUser: ", err);
				});
			}
		}

		$scope.changeUserPermission = function (role,user){

			var permission = user.permissions[role.name] ? true : false;
			var post_data = {
				'user_id': user.id,
				'role_id': role.id,
			};
			// if this is true, we should be removing it
			if(permission){
				UserService.detachRole(post_data)
				.then(function(res){
					user.permissions[role.name] = false;
				})
				.catch(function(err){
					console.error("ERROR RESPONDING FROM attachRole: ", err);
					user.permissions[role.name] = true;
				});
			}else{
				UserService.attachRole(post_data)
				.then(function(res){
					user.permissions[role.name] = true;
				})
				.catch(function(err){
					console.error("ERROR RESPONDING FROM attachRole: ", err);
					user.permissions[role.name] = false;
				});
			}
		};

		// Events Listener
		var createListener = $rootScope.$on('UserListCtrl.create', function (event, data) {
			$scope.users.push(data.payload);
		});
		var updateListener = $rootScope.$on('UserListCtrl.update', function (event, data) {
			//do nothing
		});

		$scope.$on('$destroy', function(){
			createListener();
			updateListener();
		});
	}
})();
//# sourceMappingURL=_mvmntcontrollers.js.map
